<div class=" ss-l-selectButtonWidth rotate-90 ss-hide-on-mobile" *ngIf="!isFullScreen">
    <div>
        <p-selectButton class="ss-g-selectButton-50" [options]="landscapeOptions3" (onChange)="changeViewMode()"
            [(ngModel)]="valSelectviewMode" optionLabel="name" [disabled]="recording">
            <ng-template let-option pTemplate="item">
                <div class="flex align-items-center justify-content-center">
                    <i [ngClass]="option.icon"></i>
                    <span class="font-bold">{{ option.name }}</span>
                </div>
            </ng-template>
        </p-selectButton>
    </div>
</div>
<div class="flex ss-l-slick-detail-layout">
<div #fullscreenWrapper
    class="flex align-items-center justify-content-center ss-l-preview-area-slick"
    style=" max-height: '100dvh' ">

    <div id="app">

    </div>

    <!-- splitter -->
    <div [style.visibility]="showSplitter ? 'visible' : 'hidden'" #splitterWrapper
        class="p-0 relative ss-l-splitter-wrapper" [ngClass]="[columnSize]"
        style="max-height: 100dvh; display: flex; justify-content: center; height: 100%;">

        <div #splitterWrapper2 class="splitter-container-relative col-12 md:col-12 lg:col-12 xl:col-12 2xl:col-12"
            style="position: relative;display: flex;justify-content: center;">

            <div class="p-0 unselectable ss-l-secondDivVideo" [ngClass]="[aspectRatioClass || '']">
                <!-- Botão movido pra dentro do vídeo (era irmão, fora, posicionado
                     relativo ao .splitter-container-relative — que fica com folga
                     de largura variável e deixava o botão dentro do item quando o
                     painel lateral reduz o espaço disponível). -->
                <div class="btn-container relative splitter-button-wrapper left">
                    <button pButton icon="pi pi-chevron-left" class="p-button-rounded p-button-primary 111"
                        (click)="goToPreviousItem()" [disabled]="isFirstItem()"></button>

                    <button pButton type="button" icon="pi pi-angle-left"
                        class="p-button-rounded p-button-secondary btn-interno" (click)="goToPreviousInGroup()"
                        [disabled]="isFirstInGroup()"
                        [ngStyle]="{ visibility: isFirstInGroupHidden() ? 'hidden' : 'visible' }"></button>
                </div>

                <!-- Tooltip de tempo (drag da barra de progresso) -->
                <div *ngIf="progressTooltip?.show" class="ss-l-time-display flex flex-column align-items-center"
                    style="position: absolute; bottom: 35%; left: 50%; transform: translateX(-50%); z-index: 9999; pointer-events: none;">
                    <span *ngIf="progressTooltip.chapterTitle" class="text-white font-semibold text-sm mb-1">
                        {{ progressTooltip.chapterTitle }}
                    </span>
                    <div>
                        <span class="text-white mr-1 font-bold">{{ progressTooltip.time }}</span>
                        <span class="text-white font-light">/</span>
                        <span class="text-white ml-1">{{ progressTooltip.duration }}</span>
                    </div>
                </div>

                <div #splitterTop class="splitter-panel " (click)="togglePlayPause();$event.stopPropagation();"
                    style="border-radius: 12px;">
                    <div #boxRef class="ss-g-video-overlay qualquer"></div>


                    <!-- Player Lit real embutido via iframe (substitui o <video>+overlay
                         hand-rolled: carrossel de produtos, botão de WhatsApp, cards de
                         link/CTA, hotspots, capítulos, cores e barra de progresso — tudo
                         isso já é renderizado DENTRO do player Lit real, ver
                         lit-player-embed-bridge.service.ts). Mesmo padrão de
                         video-modal.component.html — só a div-host, o player some/aparece
                         via bridge.init()/updateItem(), nunca recriando o iframe. -->
                    <div #iframeHost class="ss-lit-player-host">
                        <!-- Skeleton restaurado (existia antes da migração pro player Lit,
                             sobre o <video> antigo) — cobre tanto o carregamento inicial
                             quanto a troca de asset pelos botões laterais (loadingDetail/
                             showLoading, setados em loadSlickDetails()). Fica por CIMA do
                             iframe (z-index, ver .scss) sem interferir na criação dele —
                             o iframe é anexado nesta mesma div via
                             LitPlayerEmbedBridgeService.createIframe(), fora do template. -->
                        <div class="ss-l-media-skeleton" *ngIf="loadingDetail || showLoading"></div>
                    </div>

                    <!-- Preservados por pedido explícito do usuário ao aprovar a migração pro
                         player Lit: o p-dock (abre o painel "Gerenciar Slick"/"Opções" — únicos
                         entry points em mobile, já que o painel é docado só em desktop, ver
                         ngOnInit) e o botão de chat (abre o chat EXTERNO do app, app-profilemenu/
                         ChatSidebarComponent — não o chat interno do próprio player Lit,
                         propositalmente diferentes). Todo o resto do antigo overlay (avatar,
                         carrinho, curtir, mudo, "..." de 3 pontos, play/pause) foi removido de
                         verdade: o player Lit já tem os equivalentes próprios embutidos. -->
                    <!-- dock -->
                    <p-dock [model]="itemsDock"
                        [style]="{ 'position': 'absolute', 'top': '0', 'left': '0', 'z-index': '12' }" position="left"
                        [style]="{ 'z-index': '11' }">
                        <ng-template pTemplate="item" let-item>
                            <div (click)="item.command($event); $event.stopPropagation();">
                                <img [src]="item.icon" class="ss-l-menu-dock cursor-pointer" [alt]="item.label"
                                    width="100%" />
                            </div>
                        </ng-template>
                    </p-dock>
                    <!-- dock -->

                    <!-- Botão de chat duplicado removido: o botão de chat do
                         player Lit embutido (faixa lateral de ícones) agora
                         chama `openGlobalChat()` no Studio via bridge (ver
                         `bridge.onTrackEvent` em slick-detail.component.ts,
                         case 'openChat') — não precisa mais de um botão
                         extra fora do iframe. -->

                    <!-- Card flutuante — mobile, modo "Selecionar imagem do vídeo" com sidebar/CTAs fechados.
                         Restaurado (removido sem querer na migração pro player Lit, junto com o resto do
                         overlay antigo) — a lógica em TS (onThumbnailModeChange/exitMobileThumbnailCapture/
                         captureVideoThumbnail) nunca deixou de existir/já usa o bridge, só faltava este markup. -->
                    <div *ngIf="showMobileThumbnailCapture && !showCTAs"
                        class="ss-l-mobile-thumbnail-capture-card flex flex-column align-items-center gap-2 text-center"
                        (click)="$event.stopPropagation()">
                        <button pButton pRipple type="button" icon="pi pi-times" class="close-button"
                            (click)="exitMobileThumbnailCapture(); $event.stopPropagation();"></button>
                        <span class="text-white text-sm">Selecione um frame do vídeo e clique no botão</span>
                        <button pButton label="Salvar imagem deste momento"
                            [icon]="capturingThumbnail ? 'pi pi-spin pi-spinner' : 'pi pi-camera'"
                            [disabled]="capturingThumbnail" class="w-full"
                            (click)="captureVideoThumbnail(); $event.stopPropagation();"></button>
                    </div>

                    <p-sidebar [(visible)]="displaySidebarBottom" [modal]="true" (onHide)="onSidebarHide()"
                        class="ss-g-custom-sidebar-width ss-l-sideBarBottom ss-l-sideBarBottom2 z-9 ss-force-full-width"
                        position="bottom"
                        [style]="{position: 'absolute', height: valSelectviewMode.value == 2 ? '60%' : '35%'}">
                        <ng-template pTemplate="header">
                            <div style="display: flex; flex-direction: column;">
                                <div><b>Opções</b></div>
                            </div>
                        </ng-template>
                        <p-menu [model]="menuInferior" styleClass="ss-l-megamenu"></p-menu>
                    </p-sidebar>

                    <!-- sidebar de handleUser-->
                    <p-sidebar [(visible)]="userGridOpen" position="bottom" (onHide)="onUserGridHide()"
                        class="ss-g-custom-sidebar-width ss-l-pSidebarChat ss-l-sideBarBottom ss-l-sideBarBottom2 ss-l-productsSidebar z-9 p-0"
                        [ngClass]="{
                        'force-height-80': valSelectviewMode.value !== 2,
                        'ss-force-full-width': valSelectviewMode.value === 1
                    }" [style]="{
                        position: 'absolute',
                        width: valSelectviewMode.value === 1 ? '100%' : '50%',
                        height: valSelectviewMode.value === 2 ? '100%' : '80%',
                        left: valSelectviewMode.value === 2 ? '' : '50%',
                        zIndex: 12000,
                        transform: valSelectviewMode.value === 2 ? 'none' : 'translateX(-50%)'
                    }">
                        <!-- HEADER OFICIAL -->
                        <ng-template pTemplate="header">
                            <div class="flex justify-content-between align-items-center w-full">
                                <span class="text-lg font-normal">
                                    Posts de
                                    <b>{{ handleUser?.startsWith('@') ? handleUser : '@' + handleUser }}</b>
                                </span>
                            </div>
                        </ng-template>

                        <!-- CONTEÚDO (grid) -->
                        <div class="flex flex-column h-full">
                            <app-user-grid-sidebar class="flex-1" [isLoading]="isLoadingUserGrid"
                                [items]="userGridItems" [skeletonItems]="userGridSkeletons"
                                (itemClick)="openUserGridItem($event)">
                            </app-user-grid-sidebar>
                        </div>

                        <!-- FOOTER OFICIAL -->
                        <ng-template pTemplate="footer">
                            <div class="flex justify-content-end w-full p-2 gap-2">
                                <button pButton label="Carregar mais" class="w-full" [loading]="isLoadingUserGrid"
                                    [disabled]="!userGridNextPage || isLoadingUserGrid" (click)="loadMoreUserGrid()">
                                </button>
                            </div>
                        </ng-template>
                    </p-sidebar>


                    <!-- sidebar de handleUser -->

                    <!-- sidebar chat -->
                    <p-sidebar [visible]="screenChat" [modal]="true" (onHide)="fecharChat()"
                        (click)="$event.stopPropagation()"
                        [position]="valSelectviewMode.value == 1 ? 'bottom' : 'right'" styleClass="ss-chat-sidebar"
                        class="ss-g-custom-sidebar-width ss-l-pSidebarChat ss-l-sideBarBottom ss-l-sideBarBottom2 ss-l-productsSidebar z-9 p-0"
                        [ngClass]="{
                                'force-height-80': valSelectviewMode.value != 2,
                                'ss-force-full-width': valSelectviewMode.value == 1
                              }" [style]="{
                            position: 'absolute',
                            width: valSelectviewMode.value == 1 ? '100%' : '50%',
                            height: valSelectviewMode.value == 2 ? '100%' : '80%',
                            left: valSelectviewMode.value == 2 ? '' : '50%',
                            zIndex: 12000,
                            transform:  valSelectviewMode.value == 2 ? 'none' : 'translateX(-50%)'
                        }">
                        <ng-template pTemplate="header">
                            <div class="flex justify-content-between align-items-center w-full">
                                <h5 class="font-bold text-left m-0">Comentários</h5>
                            </div>
                        </ng-template>

                        <div class="chat-header flex flex-column gap-2 ">
                            <swiper *ngIf="pinnedMessages.length > 0"
                                [config]="{ slidesPerView: 'auto', spaceBetween: 8, freeMode: true }"
                                class="ss-g-fade-out-swiper mySwiperAlertas pinned-swiper">
                                <ng-template swiperSlide *ngFor="let alert of pinnedMessages">
                                    <div class="alert-card" [ngStyle]="{
                                            'background-color': toCssHex(alert.background)
                                          }">
                                        <div class="alert-icon-container">
                                            <i class="bi bi-pin-angle alert-icon"></i>
                                        </div>
                                        <span class="alert-label" [ngStyle]="{
                                                'color': toCssHex(alert.font_color)
                                              }">{{ alert.text }}</span>
                                    </div>
                                </ng-template>
                            </swiper>
                        </div>

                        <div class="chat-content">
                            <app-chat-app #chatBoxComponent [admin]="true" [showTopChat]="false"
                                [disableSendInput]="true" [chatId]="uuid ?? ''" [storeId]="storeId">
                            </app-chat-app>
                        </div>
                    </p-sidebar>
                    <!-- sidebar chat -->

                </div>

                <div class="btn-container relative splitter-button-wrapper right">
                    <button pButton type="button" icon="pi pi-angle-right"
                        [ngStyle]="{ visibility: isLastInGroupHidden() ? 'hidden' : 'visible' }"
                        class="p-button-rounded p-button-secondary btn-interno" (click)="goToNextInGroup()"
                        [disabled]="isLastInGroup()">
                    </button>

                    <button pButton icon="pi pi-chevron-right" class="p-button-rounded" (click)="goToNextItem()"
                        [disabled]="isLastItem()"></button>
                </div>
            </div>





        </div>


    </div>
    <!-- splitter -->
</div>

<!-- DESKTOP: painel "Gerenciar Slick" docado (mesma ideia do EditWidgetComponent) -->
<div *ngIf="!isCompactView && displaySidebar" class="ss-l-manager-panel-slot" #managerPanelSlot
    [style.min-height.px]="managerPanelSlotMinHeightPx">
    <div class="ss-l-manager-panel shadow-2" #managerPanel [class.ss-l-manager-panel-fixed]="isManagerPanelFixed"
        [style.left.px]="isManagerPanelFixed ? managerPanelLeftPx : null"
        [style.width.px]="isManagerPanelFixed ? managerPanelWidthPx : null"
        [style.max-height.px]="managerPanelMaxHeightPx">
        <div class="ss-l-manager-panel-header px-3 py-3">
            <ng-container *ngTemplateOutlet="managerHeaderTpl"></ng-container>
        </div>
        <div class="ss-l-manager-panel-body px-3">
            <ng-container *ngTemplateOutlet="managerBodyTpl"></ng-container>
        </div>
        <div class="ss-l-manager-panel-footer px-3 py-2 border-top-1 surface-border">
            <ng-container *ngTemplateOutlet="managerFooterTpl"></ng-container>
        </div>
    </div>
</div>
</div>
<p-sidebar [(visible)]="hotspotDesignOpen" [appendTo]="isMobile ? 'body' : null" class="ss-g-custom-sidebar-width"
    position="right" id="sideBarCtas" (onHide)="onHotspotDesignHide()">

    <ng-template pTemplate="header">
        <div style="display: flex; flex-direction: column;">
            <div *ngIf="sidebarGerenciar || mananger > 0" class="text-lg flex align-items-center gap-2 overflow-x-auto"
                style="white-space: nowrap;">
                <span class="cursor-pointer">Hotspot Design</span>
            </div>
        </div>
    </ng-template>
    <app-feed-help [text]="'Hotspots'" class="" [videoUrl]="'https://youtube.com/video-tutorial'"
        [supportUrl]="'https://meusite.com/suporte'">
    </app-feed-help>

    <div class="card flex flex-column gap-4">
        <!-- Tipo de Hotspot -->
        <div class="surface-border border-bottom-1 pb-4">
            <div class="font-semibold mb-2">Tipo de Hotspot</div>
            <div class="flex gap-2">
                <p-selectButton class="w-full full-width-selectbutton" [options]="hotspotMarkerOptions"
                    [(ngModel)]="hotspotMarkerType" optionLabel="name" optionValue="value"
                    (onChange)="onHotspotDesignChange()">

                    <!-- só ícones / amostras -->
                    <ng-template pTemplate="item" let-option>
                        <div class="flex align-items-center justify-content-center w-full">
                            <!-- “amostra” visual do marcador -->
                            <span class="marker-sample" [ngClass]="option.value"></span>
                        </div>
                    </ng-template>
                </p-selectButton>

            </div>
        </div>

        <!-- Shop the Look -->
        <div class="surface-card border-round-lg">
            <div class="flex align-items-center justify-content-between mb-3">
                <div class="font-semibold">Botão de ‘Shop the Look’</div>
                <p-inputSwitch [(ngModel)]="hotspotShopEnabled"
                    (ngModelChange)="onHotspotDesignChange()"></p-inputSwitch>
            </div>

            <div class="grid" *ngIf="hotspotShopEnabled">
                <div class="col-12">
                    <label class="block text-600 mb-2">texto do botão</label>
                    <input pInputText [(ngModel)]="hotspotShopLabel" (ngModelChange)="onHotspotDesignChange()"
                        placeholder="Shop the Look" class="w-full">
                </div>

                <div class="col-12 md:col-6">
                    <label class="block text-600 mb-2">cor do botão</label>
                    <p-colorPicker [(ngModel)]="hotspotShopBtnBg" (onChange)="onHotspotDesignChange()"></p-colorPicker>
                </div>

                <div class="col-12 md:col-6">
                    <label class="block text-600 mb-2">cor do texto</label>
                    <p-colorPicker [(ngModel)]="hotspotShopBtnText"
                        (onChange)="onHotspotDesignChange()"></p-colorPicker>
                </div>

                <div class="col-12">
                    <label class="block text-600 mb-2">ícone do carrinho</label>
                    <p-selectButton class="w-full" [options]="hotspotShopIconOptions"
                        (onChange)="onHotspotDesignChange()" [(ngModel)]="hotspotShopIcon" optionLabel="label"
                        optionValue="value">
                        <ng-template let-option pTemplate="item">
                            <div class="flex align-items-center justify-content-center w-full">
                                <i [ngClass]="option.icon" class="mr-2"></i>
                                <span class="font-bold">{{ option.label }}</span>
                            </div>
                        </ng-template>
                    </p-selectButton>
                </div>
            </div>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <div class="flex justify-content-end gap-2">
            <button pButton pRipple (click)="backToMainSidebar()" label="Voltar"></button>
            <button pButton pRipple label="Fechar" (click)="hotspotDesignOpen=false" class="p-button-outlined"></button>
        </div>
    </ng-template>
</p-sidebar>



<p-sidebar [(visible)]="displaySidebarSaldo" class="ss-g-custom-sidebar-width z-1" position="right" appendTo="body">
    <ng-template pTemplate="header">
        <div style="display: flex; flex-direction: column;">
            <h3 style="margin-bottom: 0;">Recarregar Saldo</h3>
        </div>
    </ng-template>
    <div class="sidebar-content">
        <p>Recarga instantânea de sua carteira.</p>
        <div class="col-12 md:col-12">
            <div class="card shadow-none">
                <div class="ss-g-container-qr-code mb-2" style="text-align: center;">
                    <i class="bi bi-lightning-fill text-xl"></i>
                    <div class="text-2xl mb-2">QR Code PIX</div>
                    <p class="mb-4" style="max-width: 50%;">Scaneie o QR Code ou copie o código
                        PIX em seu
                        app</p>
                    <div class="p-inputgroup ss-g-custom-inputgroup">
                        <input type="text" pInputText [(ngModel)]="url_share" readonly class="custom-input">
                        <button pButton pRipple type="button" icon="pi pi-copy"
                            (click)="copiarLink(); $event.stopPropagation();" class="ss-l-custom-button"></button>
                    </div>


                    <div class="ss-g-button-container-qr-code mt-2">
                        <button pButton pRipple type="button" style="padding: 0;"
                            (click)="compartilhar(); $event.stopPropagation();" icon="pi pi-share-alt"
                            class="p-button-link left-button" label="Compartilhar"></button>
                        <button pButton pRipple label="Simular preço de live" icon="bi bi-table"
                            (click)="simulateLive()" class="right-button text-xs p-1"> </button>
                    </div>
                </div>
            </div>
        </div>
    </div>



    <ng-template pTemplate="footer">
        <div style="text-align: right;">
            <button pButton pRipple (click)="closeSidebarSaldo(); $event.stopPropagation();" label="Fechar"
                class="p-button-outlined"></button>
        </div>
    </ng-template>
</p-sidebar>









<p-sidebar [(visible)]="sidebarVisible" class="ss-g-custom-sidebar-width ss-l-sideBarBottom z-1" position="bottom"
    appendTo="body" [style]="{position: 'absolute', width: '100%', height: '80%'}">
    <ng-template pTemplate="header">
        <div style="display: flex; flex-direction: column;">
            <div><b>Promoções</b></div>
        </div>
    </ng-template>

    <div class="ss-l-sidebar-bottom mt-2 mb-0 shadow-none col-12 p-0"
        *ngFor="let promotion of filteredPromotions$ | async">
        <div class="card shadow-none" *ngIf="promotion.show_item">
            {{promotion.name}}
        </div>
    </div>

</p-sidebar>








<p-sidebar [(visible)]="openDialogDragPromotion" position="right" appendTo="body">
    <div class="flex-grow-1 flex flex-column">
        <!-- Switches lado a lado -->
        <p class="font-semibold text-xl">{{ selectedProductForEdit.name }}</p>
        <div class="flex align-items-center gap-2 mb-2">
            <p-inputSwitch [(ngModel)]="selectedProductForEdit.show_item" binary="true"
                class="ss-l-switch-position3"></p-inputSwitch>
            <label>Exibir</label>
        </div>
        <div class="mb-2">
            <p-inputSwitch [(ngModel)]="selectedProductForEdit.define_interval" *ngIf="!typeLive"
                class="ss-l-switch-position2 mr-2"
                (ngModelChange)="toggleDefineIntervalPromotions($event)"></p-inputSwitch>
            <label *ngIf="!typeLive">Definir Intervalo</label>
        </div>
        <!-- Slider abaixo dos switches -->
        <div *ngIf="selectedProductForEdit.show_slider && !typeLive" class="ss-l-inputs-container mt-2 w-full">
            <div class="ss-l-inputs-row mb-2">
                <div class="ss-l-input-group">
                    <label class="ss-g-globalClassLabel">Início</label>
                    <input type="text" pInputText [(ngModel)]="selectedProductForEdit.interval_time!.start"
                        class="ss-l-half-width-input" readonly />
                </div>
                <div class="ss-l-input-group">
                    <label class="ss-g-globalClassLabel">Fim</label>
                    <input type="text" pInputText [(ngModel)]="selectedProductForEdit.interval_time!.end"
                        class="ss-l-half-width-input" readonly />
                </div>
            </div>
            <p-slider [(ngModel)]="sliderValuePromotion" [range]="true" (ngModelChange)="updateIntervalTime($event)"
                [max]="sliderMaxValue" class="w-full"></p-slider>

        </div>
    </div>

    <ng-template pTemplate="footer">
        <div style="text-align: right;">
            <button pButton pRipple (click)="closeSidebarDetailPromos()" label="Fechar" class=""></button>



        </div>
    </ng-template>
</p-sidebar>






<p-sidebar [(visible)]="showAllShortucutLinks" appendTo="body"
    class="ss-g-custom-sidebar-width ss-l-pSidebarChat ss-l-sideBarBottom z-9 p-0" position="bottom"
    [style]="{ position: 'absolute', width: valSelectviewMode.value == 1 ? '100%' : '50%', height: '65%', left: isMobile ? '0' : '50%', transform: isMobile ? 'none' : 'translateX(-50%)' }">
    <ng-template pTemplate="header">
        <div style="display: flex; justify-content: space-between; align-items: center;">
            <span class="text-xl font-bold">Links</span>
        </div>
    </ng-template>
    <!-- Container Flex para alinhar os links lado a lado -->
    <div class="ss-g-custom-container cursor-pointer">
        <div *ngFor="let link of additionalLinks$ | async" class="ss-g-links2"
            (click)="handleLinkClick(link); $event.stopPropagation();">
            <img [src]="link.click_url" class="border-circle ss-g-maxheight-links-adds" />
            <div class="ss-g-maxWidthName-links-adds">{{ link.name }}</div>
        </div>
    </div>
</p-sidebar>






<p-sidebar [(visible)]="displayCameraSidebar" position="bottom" class="z-9" appendTo="body"
    [style]="{position: 'absolute', width: isMobile ? '100%' : (fullScreen ? '33%' : '100%'), height: '65%'}">

    <h3>Selecione a Câmera</h3>
    <ul>
        <li *ngFor="let camera of cameras; let i = index" (click)="switchCamera(camera)">
            {{ camera.label || 'Câmera ' + (i + 1) }}
        </li>
    </ul>

</p-sidebar>

<!-- Não usamos *ngIf aqui: os ng-templates abaixo (#managerHeaderTpl/#managerBodyTpl/#managerFooterTpl)
     também são consumidos pelo painel docado (desktop) via *ngTemplateOutlet, e um *ngIf neste
     elemento destruiria essa view e tornaria as referências inacessíveis fora do mobile. -->
<p-sidebar [visible]="displaySidebar && isCompactView" [appendTo]="isMobile ? 'body' : null" class="ss-g-custom-sidebar-width"
    position="right" id="sideBarCtas" (onHide)="displaySidebar = false; onDialogCloseMain()">
    <ng-template #managerHeaderTpl>
        <div style="display: flex; flex-direction: column;">
            <div *ngIf="sidebarGerenciar || mananger > 0" class="text-lg flex align-items-center gap-2 overflow-x-auto"
                style="white-space: nowrap;">

                <i *ngIf="mananger > 0" class="pi pi-chevron-left text-lg ss-l-back-studio-icon cursor-pointer"
                    (click)="backStudio()">
                </i>

                <span>
                    <span (click)="closeSidebarGeral()" class="cursor-pointer"
                        [ngStyle]="{'font-weight': pageStudio === '' && pageStudioNow === '' ? 'bold' : 'normal'}">
                        Gerenciar Slick
                    </span>
                    >
                    <span class="cursor-pointer" (click)="backStudio()"
                        [ngStyle]="{'font-weight': pageStudio !== '' && pageStudioNow === '' ? 'bold' : 'normal'}">
                        {{ pageStudio }}
                    </span>
                    <span [ngStyle]="{'font-weight': pageStudioNow !== '' ? 'bold' : 'normal'}">
                        {{ pageStudioNow }}
                    </span>
                </span>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <ng-container *ngTemplateOutlet="managerHeaderTpl"></ng-container>
    </ng-template>
    <ng-container *ngTemplateOutlet="managerBodyTpl"></ng-container>
    <ng-template #managerBodyTpl>
    <app-feed-help [text]="'Slicks'" class="" [videoUrl]="'https://youtube.com/video-tutorial'"
        [supportUrl]="'https://meusite.com/suporte'">
    </app-feed-help>
    <div class="sidebar-content" *ngIf="mananger == 1">
        <div class="card p-1 mb-1">
            <div class="mb-2 w-full">
                <div class="mt-2 w-full">
                    <p-tabMenu [model]="ctaOptions" [(activeItem)]="activeItem" (change)="changeCta()"
                        [scrollable]="true" styleClass="ss-l-tabmenu-no-arrows">
                    </p-tabMenu>
                </div>
            </div>

        </div>
        <div *ngIf="activeOption === 1">
            <div *ngIf="showIntegration" class="flex flex-column gap-2 mt-3">
                <div class="card cursor-pointer border-dashed border-1 surface-border flex flex-column justify-content-center align-items-center ss-g-hover-border2 text-center shadow-none mb-0"
                    style="height:140px;" (click)="shopifyConnection()">
                    <img src="assets/shopify_glyph.png" alt="Shopify Icon" width="36" class="mb-2" />
                    <span class="font-medium">Instalar aplicativo SHOPIFY</span>
                    <span class="text-sm text-500">Instale nosso app em sua loja Shopify</span>
                </div>
                <div class="card cursor-pointer border-dashed border-1 surface-border flex flex-column justify-content-center align-items-center ss-g-hover-border2 text-center shadow-none mb-0"
                    style="height:140px;" (click)="nuvemshopConnection()">
                    <img src="assets/vagasbyintera_nuvemshop-tiendanube-og.png" alt="Nuvemshop Icon" width="36"
                        class="mb-2" />
                    <span class="font-medium">Instalar aplicativo Nuvemshop</span>
                    <span class="text-sm text-500">Instale nosso app em sua loja NuvemShop</span>
                </div>
            </div>

            <div class="p-0" *ngIf="!showIntegration">
                <app-product-picklist #productPicklist [target]="targetProducts" [isMobile]="isMobile"
                    [itemTemplate]="isMobile ? productItemTplMobile : productItemTplDesktop"
                    [targetHeaderTemplate]="targetHeaderHotspotsTpl" (moveToSource)="onMoveToSource($event)"
                    (moveToTarget)="onMoveToTarget($event)"
                    (integrationRequired)="showIntegration = $event"></app-product-picklist>

                <!-- Switch de Hotspots no header do target — específico de slick-detail (imagens),
                     projetado dentro do app-product-picklist via targetHeaderTemplate. -->
                <ng-template #targetHeaderHotspotsTpl>
                    <div *ngIf="isImage" class="flex align-items-center gap-2">
                        <p-inputSwitch [(ngModel)]="showHotspots" (ngModelChange)="toggleSwitchHotspots()"></p-inputSwitch>
                        <span class="text-lg">Hotspots</span>
                        <button pButton pRipple icon="pi pi-pencil" [disabled]="!showHotspots" class="p-button-text p-button-sm"
                            (click)="openHotspotDesignSidebar()"></button>
                    </div>
                </ng-template>

                <!-- Template de item — desktop -->
                <ng-template #productItemTplDesktop let-product let-i="index">
                    <div class="flex flex-column p-2 gap-2 z-2" [class.clickable]="product.isSelected"
                        (click)="product.isSelected">

                        <i *ngIf="product.isSelected && !isImage && chaptersAllowed" class="bi bi-collection-play p-3"
                            style="position: absolute; top: 0.5rem; right: 0.5rem; cursor: pointer;"
                            (click)="product.isSelected && openSidebarEditConfigs(product, i)"></i>

                        <div class="flex align-items-center gap-2">
                            <img class="w-4rem h-4rem shadow-2 border-round" style="object-fit: cover;"
                                src="{{ product.thumbnail }}" />
                            <div class="flex-grow-1 flex flex-column">
                                <div class="font-bold">{{ product.name }}</div>
                                <div class="text-xs text-bluegray-500">{{
                                    convertPriceProduct(product.price) | currency:'BRL':'symbol' }}
                                </div>
                            </div>
                        </div>

                        <div *ngIf="product.isSelected" class="flex-grow-1 flex flex-column">
                            <div class="flex align-items-center gap-1 col-12 p-0">
                                <div class="flex p-0 col-4">
                                    <p-inputSwitch [(ngModel)]="product.show_item" class="ss-l-switch-position mr-2"
                                        (ngModelChange)="debounceFunction(); updateShowItem(product); onHighlightChange(product);"
                                        binary="true"></p-inputSwitch>
                                    <label>Exibir</label>
                                </div>
                                <div class="flex p-0 col-4"></div>
                                <div class="flex p-0 col-4">
                                    <button pButton pRipple icon="pi pi-trash" (click)="removeProduct(product);"
                                        class="p-button-danger p-button-sm ss-l-custom-button"></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>

                <!-- Template de item — mobile -->
                <ng-template #productItemTplMobile let-product let-i="index">
                    <div class="p-2 gap-2 relative z-2">
                        <div class="flex align-items-center gap-2">
                            <div class="drag-handle" (touchstart)="productPicklist.onTouchStart($event)"
                                (touchmove)="productPicklist.onTouchMove($event)"
                                (touchend)="productPicklist.onTouchEnd($event)">
                                <i class="pi pi-arrows-alt p-2"></i>
                            </div>

                            <div class="flex align-items-center gap-2 flex-grow-1">
                                <img class="w-4rem h-4rem shadow-2 border-round" style="object-fit: cover;"
                                    [src]="product.thumbnail" alt="{{ product.name }}" />
                                <div class="flex flex-column">
                                    <div class="font-bold">{{ product.name }}</div>
                                    <div class="text-xs text-bluegray-500">
                                        {{ convertPriceProduct(product.price) | currency: 'BRL':'symbol' }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="product.isSelected" class="flex flex-column mt-2 gap-2">
                            <i *ngIf="!isImage && chaptersAllowed" class="bi bi-collection-play p-3"
                                style="position: absolute; top: 0.5rem; right: 0.5rem; cursor: pointer;"
                                (click)="openSidebarEditConfigs(product, i)">
                            </i>

                            <div class="flex align-items-center gap-1">
                                <div class="flex col-4">
                                    <p-inputSwitch [(ngModel)]="product.show_item" class="ss-l-switch-position mr-2"
                                        (ngModelChange)="debounceFunction(); updateShowItem(product); onHighlightChange(product);"
                                        binary="true"></p-inputSwitch>
                                    <label>Exibir</label>
                                </div>
                                <div class="flex col-4"></div>
                                <div class="flex col-4">
                                    <button pButton pRipple icon="pi pi-trash" (click)="removeProduct(product)"
                                        class="p-button-danger p-button-sm ss-l-custom-button"></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>

            </div>
        </div>
        <div *ngIf="activeOption === 2">
            <!-- Conteúdo para Custom -->

            <p-accordion *ngIf="accordionTabs.length > 0; else noCustomMessage" [activeIndex]="0"
                class="ss-l-accordion mb-2">
                <p-accordionTab *ngFor="let tab of accordionTabs; let i = index" [header]="'Botão ' + (i + 1)">
                    <div class="card shadow-none">
                        <div class="p-fluid">
                            <div class="p-field mb-2">
                                <label for="buttonText" class="ss-g-globalClassLabel">Texto do botão</label>
                                <input id="buttonText" class="mt-2" type="text" pInputText maxlength="20"
                                    [(ngModel)]="tab.button_text" (click)="forceFocus($event)"
                                    placeholder="ex: texto do botão"
                                    (ngModelChange)="debounceFunction(); setupVisibleButton(); pushLiveUpdate();" />
                            </div>

                            <div class="p-field mb-2">
                                <label for="redirectUrl" class="ss-g-globalClassLabel">URL de
                                    redirecionamento</label>
                                <div class="p-inputgroup mt-2">
                                    <span class="p-inputgroup-addon">https://</span>
                                    <input id="redirectUrl" type="text" pInputText placeholder="ex: www.example.com"
                                        (click)="forceFocus($event)" [(ngModel)]="tab.redirect_url"
                                        (ngModelChange)="debounceFunction(); setupVisibleButton(); pushLiveUpdate();" />
                                </div>
                            </div>


                            <div class="p-formgrid p-grid">
                                <div class="p-field p-col mb-2">
                                    <label for="fontColor" class="ss-g-globalClassLabel">Cor da
                                        fonte</label>
                                    <div class="mt-2"></div>
                                    <p-colorPicker class="mt-2 mb-2" id="fontColor" [(ngModel)]="tab.font_color_custom"
                                        format="hex" (ngModelChange)="setCurrentTabAndDebounce(tab)"
                                        [style]="{'width':'100%'}"></p-colorPicker>
                                </div>
                                <div class="p-field p-col mb-2">
                                    <label for="bgColor" class="ss-g-globalClassLabel">Cor do fundo</label>
                                    <div class="mt-2"></div>
                                    <p-colorPicker class="mt-2 mb-2" id="bgColor" [(ngModel)]="tab.bg_color_custom"
                                        format="hex" (ngModelChange)="setCurrentTabAndDebounce(tab)"
                                        [style]="{'width':'100%'}"></p-colorPicker>
                                </div>
                            </div>

                            <div class="flex center between mb-0 mt-4 col-12 p-0">
                                <div class="flex left col-4 p-0">
                                    <p-inputSwitch [(ngModel)]="tab.show_item" class="ss-l-switch-position mr-2"
                                        (ngModelChange)="debounceFunction(); setupVisibleButton(); pushLiveUpdate();"
                                        class="mr-2"></p-inputSwitch>

                                    <label class="p-mr-5">Exibir</label>
                                </div>
                                <div class="flex left col-6 p-0" *ngIf="!typeLive">
                                    <!-- <p-inputSwitch [(ngModel)]="tab.define_interval" [disabled]="!tab.show_item"
                                        class="ss-l-switch-position mr-2"
                                        (ngModelChange)="handleDefineIntervalChange(tab); debounceFunction()"
                                        class="mr-2"></p-inputSwitch>

                                    <label class="p-mr-5">Definir Intervalo</label> -->
                                </div>
                                <div class="col-2 p-0 text-center">
                                    <i class="pi pi-trash cursor-pointer" (click)="removeComponentCustom(i)"></i>
                                </div>

                            </div>

                            <div class="p-field ss-l-inputs-container"
                                *ngIf="!typeLive && tab.define_interval && tab.show_item">
                                <div class="ss-l-inputs-row mb-2">
                                    <div class="ss-l-input-group">
                                        <label class="ss-g-globalClassLabel">Início</label>
                                        <input type="text" pInputText [(ngModel)]="tab.interval_time!.start"
                                            (ngModelChange)="updateSliderFromInput(tab, 'start', $event)"
                                            class="ss-l-half-width-input" readonly />
                                    </div>
                                    <div class="ss-l-input-group">
                                        <label class="ss-g-globalClassLabel">Fim</label>
                                        <input type="text" pInputText [(ngModel)]="tab.interval_time!.end"
                                            (ngModelChange)="updateSliderFromInput(tab, 'end', $event)"
                                            class="ss-l-half-width-input" readonly />
                                    </div>
                                </div>
                                <p-slider [(ngModel)]="tab.slider_time_range" (click)="forceFocus($event)"
                                    [max]="sliderMaxValue" [range]="true"
                                    (onChange)="updateInputsFromSlider(tab, $event)" class="w-full"></p-slider>
                            </div>
                        </div>
                    </div>
                </p-accordionTab>
            </p-accordion>
            <ng-template #noCustomMessage>
                <div class="flex flex-column align-items-center justify-content-center py-4 text-center">
                    <i class="pi pi-palette text-4xl text-primary mb-3"></i>
                    <span class="text-lg font-semibold text-900 mb-1">Crie botões personalizados</span>
                    <span class="text-sm text-400 font-light mb-3 px-3">Adicione botões customizados para exibir no seu slick.</span>
                    <button icon="pi pi-plus" (click)="addComponentCustom()" pButton pRipple class="p-button-rounded"></button>
                </div>
            </ng-template>
            <div class="flex justify-content-center" *ngIf="accordionTabs.length > 0 && !isAddButtonDisabled">
                <button icon="pi pi-plus" (click)="addComponentCustom()" pButton pRipple class="p-button-rounded mt-2"
                    [disabled]="isAddButtonDisabled"></button>
            </div>

        </div>

        <div *ngIf="activeOption === 3">
            <!-- Conteúdo para Whatsapp -->

            <p-accordion *ngIf="whatsappTabs.length > 0; else noWhatsappMessage" [activeIndex]="0"
                class="ss-l-accordion mb-2">
                <p-accordionTab *ngFor="let tab of whatsappTabs; let i = index" [header]="'Whatsapp ' + (i + 1)">
                    <div class="card shadow-none">
                        <div class="p-fluid">
                            <div class="col-12 p-0 mt-2 mb-4">
                                <label for="mensagem-{{i}}" class="ss-g-globalClassLabel">Mensagem padrão do
                                    WhatsApp</label>
                                <div class="mb-2"></div>
                                <textarea [id]="'mensagem-' + i"
                                    class="w-full p-inputtextarea p-inputtext p-component p-element"
                                    placeholder="Digite a mensagem que será enviada ao abrir o WhatsApp" rows="2"
                                    [(ngModel)]="tab.whatsappMsg" (ngModelChange)="debounceFunction(); pushLiveUpdate();" pInputTextarea>
                                </textarea>
                            </div>

                            <div class="grid mx-0 align-items-center mb-4">
                                <!-- Seleção do país e DDI -->
                                <div class="col-4 p-0">
                                    <label for="ddi-{{i}}" class="ss-g-globalClassLabel">DDI</label>
                                    <p-dropdown [options]="countries" [(ngModel)]="tab.ddi" optionLabel="name"
                                        placeholder="Select a Country" class="w-full mt-2"
                                        (ngModelChange)="debounceFunction(); pushLiveUpdate();">

                                        <!-- Template para os itens da lista -->
                                        <ng-template let-country pTemplate="item">
                                            <div class="flex align-items-center">
                                                <img src="assets/demo/images/flag/flag_placeholder.png"
                                                    [class]="'flag flag-' + country.code.toLowerCase()" alt="Flag"
                                                    style="width:21px" />
                                                <span class="ml-2">({{ country.ddi }})</span>
                                            </div>
                                        </ng-template>

                                        <!-- Template para o item selecionado -->
                                        <ng-template let-country pTemplate="selectedItem">
                                            <div class="flex align-items-center">
                                                <img src="assets/demo/images/flag/flag_placeholder.png"
                                                    [class]="'flag flag-' + country.code.toLowerCase()" alt="Flag"
                                                    style="width:21px" />
                                                <span class="ml-2">({{ country.ddi }})</span>
                                            </div>
                                        </ng-template>

                                    </p-dropdown>
                                </div>

                                <!-- Campo DDD -->
                                <div class="col-2 p-0 ml-2"> <!-- Adiciona margem apenas aqui -->
                                    <label for="ddd-{{i}}" class="ss-g-globalClassLabel">DDD</label>
                                    <input [id]="'ddd-' + i" class="w-full" inputmode="numeric" pInputText mask="00"
                                        (input)="limitInput($event)" (keydown)="preventE($event)"
                                        (ngModelChange)="debounceFunction(); pushLiveUpdate();" [(ngModel)]="tab.ddd" placeholder="ex: 99"
                                        type="text" />
                                </div>

                                <!-- Campo Fone -->
                                <div class="col-5 p-0 ml-2"> <!-- Adiciona margem apenas aqui -->
                                    <label for="fone-{{i}}" class="ss-g-globalClassLabel">Fone</label>
                                    <input [id]="'fone-' + i" class="w-full " type="text" pInputText inputmode="numeric"
                                        (ngModelChange)="debounceFunction(); pushLiveUpdate();" mask="00000-0000" [(ngModel)]="tab.fone"
                                        placeholder="ex: 99999-9999" />
                                </div>
                            </div>


                            <div class="flex center between mb-2 mt-2">
                                <div class="flex left col-4 p-0">
                                    <p-inputSwitch [(ngModel)]="tab.show_item" class="ss-l-switch-position mr-2"
                                        (onChange)="debounceFunction(); setupVisibleButtonWhatsApp(); pushLiveUpdate();"
                                        class="mr-2"></p-inputSwitch>
                                    <label class="p-mr-5">Exibir</label>
                                </div>
                                <div class="flex left col-6 p-0" *ngIf="!typeLive">

                                </div>
                                <div class="col-2 p-0 text-center">
                                    <i class="pi pi-trash cursor-pointer" (click)="removeComponentWhatsapp(i)"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </p-accordionTab>
            </p-accordion>
            <ng-template #noWhatsappMessage>
                <div class="flex flex-column align-items-center justify-content-center py-4 text-center">
                    <i class="pi pi-whatsapp text-4xl mb-3" style="color: #25D366;"></i>
                    <span class="text-lg font-semibold text-900 mb-1">Adicione um atalho de WhatsApp</span>
                    <span class="text-sm text-400 font-light mb-3 px-3">Exiba um botão de WhatsApp para entrarem em contato.</span>
                    <button (click)="addComponentWhatsApp()" pButton pRipple icon="pi pi-plus"
                        class="p-button-rounded" [disabled]="isAddButtonDisabledWhats"></button>
                </div>
            </ng-template>
            <div class="flex justify-content-center" *ngIf="whatsappTabs.length > 0">
                <button (click)="addComponentWhatsApp()" pButton pRipple icon="pi pi-plus"
                    class="p-button-rounded mt-2" [disabled]="isAddButtonDisabledWhats"></button>
            </div>

        </div>

        <div *ngIf="activeOption === 4">
            <!-- Conteúdo para Promoções -->

            <div class="p-0">
                <p-pickList [source]="sourcePromotions" [target]="targetPromotions" sourceHeader="Disponíveis"
                    [responsive]="true" class="z-2" [dragdrop]="true" targetHeader="Selecionados" filterBy="name"
                    sourceFilterPlaceholder="Buscar por nome" targetFilterPlaceholder="Buscar por nome"
                    (onMoveToTarget)="onMoveToTargetPromos($event)" (onMoveToSource)="onMoveToSourcePromos($event)">
                    <ng-template let-promotion pTemplate="item" let-i="index">
                        <!-- Contêiner principal para o item, com direção da coluna para empilhar conteúdo verticalmente -->
                        <div class="flex flex-column p-2 gap-2 z-2" [class.clickable]="promotion.isSelected"
                            (click)="promotion.isSelected">

                            <i *ngIf="promotion.isSelected" class="bi bi-three-dots-vertical p-3"
                                style="position: absolute; top: 0.5rem; right: 0.5rem;"
                                (click)="promotion.isSelected && openSidebarEditConfigsPromotion(promotion, i)"></i>

                            <!-- Contêiner para a linha da imagem e detalhes do produto -->
                            <div class="flex align-items-center gap-2">
                                <!-- Imagem à esquerda -->
                                <!-- Nome e preço ao lado da imagem -->
                                <div class="flex-grow-1 flex flex-column">
                                    <div class="font-bold">{{ promotion.name }}</div>
                                    <div class="text-xs text-bluegray-500">{{ promotion.value |
                                        currency:'BRL':'symbol' }}</div>
                                </div>
                            </div>

                            <!-- Contêiner para os switches e o slider, apenas visível quando selecionado -->
                            <div *ngIf="promotion.isSelected" class="flex-grow-1 flex flex-column">
                                <!-- Switches lado a lado -->
                                <div class="flex align-items-center gap-2 col-12 p-0">
                                    <div class="col-6 p-0">
                                        <p-inputSwitch [(ngModel)]="promotion.show_item"
                                            (onChange)="debounceFunction();" class="ss-l-switch-position2 mr-2"
                                            binary="true"></p-inputSwitch>
                                        <label>Exibir</label>
                                    </div>
                                    <div class="flex p-0 col-6 text-center">
                                        <button pButton pRipple icon="pi pi-trash" (click)="removePromotion(promotion)"
                                            class="p-button-danger p-button-sm ss-l-custom-button"></button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </ng-template>
                </p-pickList>
            </div>
        </div>

        <div *ngIf="activeOption === 5">
            <!-- Conteúdo para Alertas -->
            <p-accordion *ngIf="alertsTabs.length > 0; else noAlertsMessage" [activeIndex]="0"
                class="ss-l-accordion mb-2">
                <p-accordionTab *ngFor="let tab of alertsTabs; let i = index" [header]="'Alerta ' + (i + 1)">
                    <div class="card shadow-none">
                        <div class="p-fluid">
                            <div class="p-field mb-2">
                                <label for="alertText-{{i}}" class="ss-g-globalClassLabel">Insira seu
                                    alerta</label>
                                <input pInputText class="mt-2" id="alertText-{{i}}" [(ngModel)]="tab.text"
                                    placeholder="ex: Texto do alerta" type="text" (click)="forceFocus($event)"
                                    (ngModelChange)="handleChanges(i, 'text', $event)" maxlength="30" />
                            </div>

                            <div class="p-formgrid p-grid mb-3">
                                <div class="p-field p-col mb-2">
                                    <label for="fontColor-{{i}}" class="ss-g-globalClassLabel">Cor da
                                        fonte</label>
                                    <div class="mt-2"></div>
                                    <p-colorPicker id="fontColor-{{i}}" [(ngModel)]="tab.font_color" format="hex"
                                        (ngModelChange)="handleChanges(i, 'fontColor', $event)"
                                        [style]="{'width':'100%'}"></p-colorPicker>
                                </div>
                                <div class="p-field p-col mb-2">
                                    <label for="bgColor-{{i}}" class="ss-g-globalClassLabel">Cor do
                                        fundo</label>
                                    <div class="mt-2"></div>
                                    <p-colorPicker id="bgColor-{{i}}" [(ngModel)]="tab.background" format="hex"
                                        (ngModelChange)="handleChanges(i, 'backgroundColor', $event)"
                                        [style]="{'width':'100%'}"></p-colorPicker>
                                </div>
                            </div>

                            <div class="flex center between mb-2 mt-2 col-12 p-0">
                                <div class="flex left col-4 p-0">
                                    <p-inputSwitch [(ngModel)]="tab.show_item" (ngModelChange)="changeShowAlert()"
                                        class="mr-2"></p-inputSwitch>
                                    <label class="p-mr-5">Exibir</label>
                                </div>
                                <div class="flex left col-6 p-0" *ngIf="!typeLive">
                                    <!-- <p-inputSwitch [(ngModel)]="tab.define_interval" [disabled]="!tab.show_item"
                                        (ngModelChange)="changeIntervalAlert()" class="mr-2"></p-inputSwitch>
                                    <label class="p-mr-5">Definir Intervalo</label> -->
                                </div>
                                <div class="col-2 p-0 text-center">
                                    <i class="pi pi-trash cursor-pointer" (click)="removeComponentAlerts(i)"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </p-accordionTab>
            </p-accordion>
            <ng-template #noAlertsMessage>
                <div class="flex flex-column align-items-center justify-content-center py-4 text-center">
                    <i class="pi pi-bell text-4xl text-orange-500 mb-3"></i>
                    <span class="text-lg font-semibold text-900 mb-1">Configure alertas interativos</span>
                    <span class="text-sm text-400 font-light mb-3 px-3">Adicione alertas para chamar a atenção dos visitantes.</span>
                    <button icon="pi pi-plus" (click)="addComponentAlerts()" pButton pRipple class="p-button-rounded"></button>
                </div>
            </ng-template>

            <div class="flex justify-content-center" *ngIf="alertsTabs.length > 0">
                <button icon="pi pi-plus" (click)="addComponentAlerts()" pButton pRipple
                    class="p-button-rounded mt-2"></button>
            </div>
        </div>

        <div *ngIf="activeOption === 6">
            <!-- Links -->
            <div class="scroll-container">
                <p-orderList #orderList header="Links ({{ linksSelecteds.length }})" *ngIf="!isMobile"
                    [value]="linksSelecteds" class="ss-l-order-list" (onReorder)="onReorder($event)" [dragdrop]="true"
                    [listStyle]="{'height':'350px', 'overflow-y': 'auto'}">
                    <ng-template let-link let-i="index" pTemplate="item">
                        <div class="flex-container-links">
                            <div class="link-name">
                                <img [src]="link.click_url" style="width: 15px; height: auto;">
                                <span class="link-name-text">{{ link.name }}</span>
                            </div>
                            <div class="right-aligned-items">
                                <div class="switch-container">
                                    <span class="mr-1 font-light" *ngIf="!isMobile">Exibir</span>
                                    <p-inputSwitch [(ngModel)]="link.show_item"
                                        (onChange)="updateShowLink(link, link.show_item)" binary="true"></p-inputSwitch>
                                </div>
                                <i class="pi pi-trash cursor-pointer" (click)="removeLink(i)"></i>
                                <i class="bi bi-three-dots-vertical icon-item cursor-pointer"
                                    (click)="selectedLink(link, i)"></i>
                            </div>

                        </div>
                    </ng-template>
                    <ng-template pTemplate="empty">
                        <div class="flex flex-column align-items-center justify-content-center py-4 text-center">
                            <i class="pi pi-link text-4xl text-blue-500 mb-3"></i>
                            <span class="text-lg font-semibold text-900 mb-1">Adicione links personalizados</span>
                            <span class="text-sm text-400 font-light mb-3 px-3">Crie links com imagens próprias, texto e URL para exibir no slick.</span>
                            <button icon="pi pi-plus" (click)="addLinks()" pButton pRipple class="p-button-rounded"></button>
                        </div>
                    </ng-template>
                </p-orderList>
                <p-orderList *ngIf="isMobile" #orderList [value]="linksSelecteds" class="ss-l-order-list"
                    (onReorder)="onReorder($event)" [dragdrop]="isDragDrop"
                    [listStyle]="{'height':'350px', 'overflow-y': 'auto'}">
                    <ng-template pTemplate="header">
                        <div>
                            Links ({{ linksSelecteds.length }}) <i *ngIf="isDragDrop" class="pi pi-arrows-alt p-2"></i>
                        </div>
                    </ng-template>
                    <ng-template let-link let-i="index" pTemplate="item">
                        <div class="flex-container-links" (click)="dragDrop(1)">
                            <div (mousedown)="dragDrop(0, $event)" (touchstart)="onTouchStart($event)"
                                (touchmove)="onTouchMove($event)" (touchend)="onTouchEnd($event)">
                                <i class="pi pi-arrows-alt p-2"></i>
                            </div>
                            <div class="link-name">
                                <img [src]="link.click_url" style="width: 15px; height: auto;">
                                <span class="link-name-text">{{ link.name }}</span>
                            </div>
                            <div class="right-aligned-items" (click)="dragDrop(1)">
                                <div class="switch-container">
                                    <span class="mr-1 font-light" *ngIf="!isMobile">Exibir</span>
                                    <p-inputSwitch [(ngModel)]="link.show_item"
                                        (onChange)="updateShowLink(link, link.show_item)" binary="true"></p-inputSwitch>
                                </div>
                                <i class="pi pi-trash cursor-pointer" (click)="removeLink(i)"></i>
                                <i class="bi bi-three-dots-vertical icon-item cursor-pointer"
                                    (click)="selectedLink(link, i)"></i>
                                <span class="link-name">
                                    <img [src]="getLinkIcon(link.link_type)" style="width: 20px; height: auto;">
                                </span>
                            </div>

                        </div>
                    </ng-template>
                    <ng-template pTemplate="empty">
                        <div class="flex flex-column align-items-center justify-content-center py-4 text-center">
                            <i class="pi pi-link text-4xl text-blue-500 mb-3"></i>
                            <span class="text-lg font-semibold text-900 mb-1">Adicione links personalizados</span>
                            <span class="text-sm text-400 font-light mb-3 px-3">Crie links com imagens próprias, texto e URL para exibir no slick.</span>
                            <button icon="pi pi-plus" (click)="addLinks()" pButton pRipple class="p-button-rounded"></button>
                        </div>
                    </ng-template>
                </p-orderList>
            </div>

            <div class="flex justify-content-center" *ngIf="linksSelecteds.length > 0">
                <button icon="pi pi-plus" (click)="addLinks()" pButton pRipple class="p-button-rounded mt-2"></button>
            </div>
        </div>


    </div>
    <div class="sidebar-content" *ngIf="mananger == 2">

        <div class="card">
            <div class="grid mx-0  align-center p-justify-between ss-l-custom-slicks-sidebar p-2 "
                [ngClass]="{ 'mt-0': mediaType?.toLowerCase() === 'photo' }">
                <div class="col-12 mx-0 p-0"
                    [ngClass]="{ 'surface-border border-bottom-1': mediaType?.toLowerCase() !== 'photo' }"
                    *ngIf="handleUser !== ''">
                    <div class="grid mx-0 p-0 align-items-center ml-3"
                        [ngClass]="{ 'mb-3': mediaType?.toLowerCase() !== 'photo' }" style="padding: 0;margin: 0;">
                        <!-- Ícone à esquerda -->
                        <div class="col-2 mx-0 p-0">
                            <i class="bi bi-person-circle mr-2" style="font-size: 2rem;"></i>
                        </div>
                        <!-- Conteúdo do centro com título e texto  [ngClass]="{ 'disabled-config': mediaType?.toLowerCase() === 'photo' }"
                    [ngStyle]="mediaType?.toLowerCase() === 'photo' ? { 'pointer-events': 'none' } : {}"-->
                        <div class="col-8 mx-0 p-0 align-items-center mb-2">
                            <div>
                                <div class="text-xl font-bold mb-1" [ngClass]="{'toMobToolTip': isMobileDevice()}">
                                    Botão de Perfil<!-- Configuração de Profile Button -->
                                    <i class="bi bi-info-circle ml-2" *ngIf="!isMobileDevice(); else mobileTooltip"
                                        pTooltip="Mais posts do autor exibidos ao clicar no botão de perfil"
                                        tooltipPosition="right" tooltipEvent="focus" tabindex="0"></i>
                                    <ng-template #mobileTooltip>
                                        <app-mobile-tooltip
                                            text="Mais posts do autor exibidos ao clicar no botão de perfil"
                                            position="right">
                                            <i class="bi bi-info-circle ml-2"></i>
                                        </app-mobile-tooltip>
                                    </ng-template>
                                </div>
                                <p>Mais posts do autor exibidos ao clicar no botão de perfil</p>
                            </div>
                        </div>


                        <!-- Seta à direita -->
                        <p-inputSwitch [(ngModel)]="profileBtn" binary="true" (ngModelChange)="saveProfileBtn()"
                            class="col-2 text-right mx-0 p-0"></p-inputSwitch>
                    </div>
                </div>

                <!-- Sem handle do autor (import de hashtag/tags que não resolveu) —
                     em vez de esconder Configurações inteira, só bloqueia esse
                     toggle específico e oferece tentar recuperar via insights. -->
                <div class="col-12 mx-0 p-0"
                    [ngClass]="{ 'surface-border border-bottom-1': mediaType?.toLowerCase() !== 'photo' }"
                    *ngIf="handleUser === '' && source_id === 'ig'">
                    <div class="grid mx-0 p-0 align-items-center ml-3"
                        [ngClass]="{ 'mb-3': mediaType?.toLowerCase() !== 'photo' }" style="padding: 0;margin: 0;">
                        <div class="col-2 mx-0 p-0">
                            <i class="bi bi-person-circle mr-2 text-400" style="font-size: 2rem;"></i>
                        </div>
                        <div class="col-8 mx-0 p-0 align-items-center mb-2">
                            <div>
                                <div class="text-xl font-bold mb-1 text-400">Botão de Perfil</div>
                                <p class="text-400">Não conseguimos identificar o autor original desse post.</p>
                            </div>
                        </div>
                        <div class="col-2 text-right mx-0 p-0">
                            <button pButton pRipple type="button" class="p-button-text p-button-rounded"
                                [icon]="loadingInsightsHandle ? 'pi pi-spin pi-spinner' : 'pi pi-refresh'"
                                [disabled]="loadingInsightsHandle" pTooltip="Atualizar Insights"
                                tooltipPosition="top" (click)="atualizarInsightsHandle()"></button>
                        </div>
                    </div>
                </div>

                <div class="col-12 mx-0 p-0 surface-border border-bottom-1 "
                    *ngIf="mediaType?.toLowerCase() !== 'photo'">
                    <div class="grid mx-0 p-0 mb-3 mt-4 align-items-center ml-3" style="padding: 0;margin: 0;">
                        <!-- Ícone à esquerda -->
                        <div class="col-2 mx-0 p-0">
                            <i class="bi bi-play-circle-fill mr-2" style="font-size: 2rem;"></i>
                        </div>
                        <!-- Conteúdo do centro com título e texto -->
                        <div class="col-8 mx-0 p-0 align-items-center mb-2">
                            <div>
                                <div class="text-xl font-bold mb-1" [ngClass]="{'toMobToolTip': isMobileDevice()}">
                                    Smart Autoplay
                                    <i class="bi bi-info-circle" *ngIf="!isMobileDevice(); else mobileTooltip"
                                        pTooltip="O vídeo começa a tocar assim que o usuário abre"
                                        tooltipPosition="right" tooltipEvent="focus" tabindex="0"></i>
                                    <ng-template #mobileTooltip>
                                        <app-mobile-tooltip text="O vídeo começa a tocar assim que o usuário abre"
                                            position="right">
                                            <i class="bi bi-info-circle ml-2"></i>
                                        </app-mobile-tooltip>
                                    </ng-template>
                                </div>
                                <p>O vídeo começa a tocar assim que o usuário abre</p>
                            </div>
                        </div>


                        <!-- Seta à direita -->
                        <p-inputSwitch [(ngModel)]="smartAutoPlay" binary="true" [disabled]="typeLive" [disabled]="true"
                            (ngModelChange)="debounceFunction()" class="col-2 text-right mx-0 p-0"></p-inputSwitch>
                    </div>
                </div>

                <!-- -->

                <div class="col-12 mx-0 p-0 surface-border border-bottom-1"
                    *ngIf="mediaType?.toLowerCase() !== 'photo'">
                    <div class="grid mx-0 p-0 mb-3 mt-4 align-items-center ml-3" style="padding: 0;margin: 0;">
                        <!-- Ícone à esquerda -->
                        <div class="col-2 mx-<0 p-0">
                            <i class="bi bi-rocket-takeoff mr-2" style="font-size: 2rem;"></i>
                        </div>
                        <!-- Conteúdo do centro com título e texto -->
                        <div class="col-8 mx-0 p-0 align-items-center mb-2">
                            <div>
                                <div class="text-xl font-bold mb-1" [ngClass]="{'toMobToolTip': isMobileDevice()}">
                                    Exibir barra de progresso
                                    <i class="bi bi-info-circle" *ngIf="!isMobileDevice(); else mobileTooltipShowProgressBar"
                                        pTooltip="Mostra ou esconde a barra de progresso do vídeo" tooltipPosition="right"
                                        tooltipEvent="focus" tabindex="0"></i>
                                    <ng-template #mobileTooltipShowProgressBar>
                                        <app-mobile-tooltip text="Mostra ou esconde a barra de progresso do vídeo"
                                            position="left">
                                            <i class="bi bi-info-circle ml-2"></i>
                                        </app-mobile-tooltip>
                                    </ng-template>
                                </div>
                                <p>Mostra ou esconde a barra de progresso do vídeo</p>
                            </div>
                        </div>


                        <!-- Seta à direita -->
                        <p-inputSwitch [ngModel]="showProgressBar$ | async"
                            (ngModelChange)="debounceFunction(); setShowProgressBar($event); pushLiveUpdate();" [disabled]="typeLive"
                            binary="true" class="col-2 text-right mx-0 p-0"></p-inputSwitch>
                    </div>
                </div>

                <!-- -->

                <div class="col-12 mx-0 p-0 surface-border border-bottom-1"
                    *ngIf="mediaType?.toLowerCase() !== 'photo'">
                    <div class="grid mx-0 p-0 mb-3 mt-4 align-items-center ml-3" style="padding: 0;margin: 0;">
                        <!-- Ícone à esquerda -->
                        <div class="col-2 mx-0 p-0">
                            <i class="bi bi-hourglass-bottom mr-2" style="font-size: 2rem;"></i>
                        </div>
                        <!-- Conteúdo do centro com título e texto -->
                        <div class="col-8 mx-0 p-0 align-items-center mb-2">
                            <div>
                                <div class="text-xl font-bold mb-1" [ngClass]="{'toMobToolTip': isMobileDevice()}">
                                    Tempo até o Pitch
                                    <i class="bi bi-info-circle" *ngIf="!isMobileDevice(); else mobileTooltipTempoPitch"
                                        pTooltip="É a parte do vídeo que apresenta a oferta" tooltipPosition="right"
                                        tooltipEvent="focus" tabindex="0"></i>
                                    <ng-template #mobileTooltipTempoPitch>
                                        <app-mobile-tooltip text="É a parte do vídeo que apresenta a oferta"
                                            position="left">
                                            <i class="bi bi-info-circle ml-2"></i>
                                        </app-mobile-tooltip>
                                    </ng-template>
                                </div>
                                <p>É a parte do vídeo que apresenta a oferta</p>
                            </div>
                        </div>






                        <!-- Seta à direita -->
                        <p-inputSwitch [(ngModel)]="timeToPitch" (ngModelChange)="debounceFunction(); pushLiveUpdate();"
                            (click)="forceFocus($event)" [disabled]="typeLive" binary="true"
                            class="col-2 text-right mx-0 p-0"></p-inputSwitch>
                    </div>
                    <div class="p-field mb-5" *ngIf="timeToPitch">
                        <label for="tconfig" class="w-full ss-g-globalClassLabel">Tempo do vídeo</label>
                        <input id="tconfig" [(ngModel)]="timePitch" [disabled]="typeLive" class="w-full mt-2 mb-2"
                            type="text" pInputText placeholder="ex: 00h03m05s" readonly />

                        <p-slider [(ngModel)]="sliderValuePitch" [min]="0" [max]="sliderMaxValue"
                            [style]="{'width':'100%'}" (onChange)="updateTimeValue()"></p-slider>

                    </div>
                </div>


                <div class="col-12 mx-0 p-0" *ngIf="mediaType?.toLowerCase() !== 'photo'">
                    <div class="grid mx-0 p-0 mb-3 mt-4 align-items-center ml-3" style="padding: 0;margin: 0;">
                        <!-- Ícone à esquerda -->
                        <div class="col-2 mx-0 p-0">
                            <i class="bi bi-brush-fill mr-2" style="font-size: 2rem;"></i>
                        </div>
                        <!-- Conteúdo do centro com título e texto -->
                        <div class="col-8 mx-0 p-0 align-items-center mb-2">
                            <div>
                                <span class="text-xl font-bold mb-2" [ngClass]="{'toMobToolTip': isMobileDevice()}">
                                    Cores
                                    <i class="bi bi-info-circle" *ngIf="!isMobileDevice(); else mobileTooltipCores"
                                        pTooltip="Defina as cores do seu player" tooltipPosition="right"
                                        tooltipEvent="focus" tabindex="0"></i>
                                    <ng-template #mobileTooltipCores>
                                        <app-mobile-tooltip text="Defina as cores do seu player" position="right">
                                            <i class="bi bi-info-circle ml-2"></i>
                                        </app-mobile-tooltip>
                                    </ng-template>
                                </span>
                                <p>Defina as cores do seu player</p>
                            </div>
                        </div>

                    </div>
                    <div class="grid mt-2">
                        <div class="col-12">
                            <label class="ss-g-globalClassLabel">Cor do Play/Pause</label>
                            <div class="mt-2"></div>
                            <p-colorPicker [(ngModel)]="playPauseColor" format="hex" [disabled]="typeLive"
                                (onChange)="updatePlayPauseColor($event.value)" class="w-full"
                                (ngModelChange)="debounceFunction()"></p-colorPicker>
                        </div>
                        <div class="col-12">
                            <label class="ss-g-globalClassLabel mt-2">Cor da barra de progresso</label>
                            <div class="mt-2"></div>
                            <p-colorPicker [(ngModel)]="progressBarColor" format="hex" [disabled]="typeLive"
                                (onChange)="updateProgressBarColor($event.value)" (ngModelChange)="debounceFunction()"
                                class="w-full"></p-colorPicker>
                        </div>


                    </div>
                </div>
            </div>
        </div>

    </div>
    <div class="sidebar-content" *ngIf="mananger == 3">
        <p>Teste A/B.</p>
    </div>
    <div class="sidebar-content" *ngIf="mananger == 4">
        <p>Veja em tempo real a atualização dos números de sua apresentação</p>
        <!-- -->
        <div class="grid">
            <!-- <div class="col-12 md:col-6 xl:col-12 mb-2">
                            <div class="card h-full">
                                <ng-container>
                                    <span class="font-semibold text-lg"><i class="pi pi-eye mr-2"></i> Espectadores
                                        agora</span>
                                    <div class="flex justify-content-between align-items-start mt-3">
                                        <div class="w-12">
                                            <span class="text-4xl font-bold text-900" style="margin: 0;">
                                                {{numViewers}}</span><span
                                                class="ml-4 text-sm text-bluegray-500 ss-l-analytics-txt">Quantidade de
                                                espectadores ao
                                                vivo</span>
                                            <div class="text-green-500">
                                            
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-template #loadingTemplate>
                                    <p-skeleton width="100%" height="1.5rem"></p-skeleton>
                                    <p-skeleton width="100%" height="1rem"></p-skeleton>
                                    <p-skeleton width="60%" height="1rem"></p-skeleton>
                                </ng-template>
                            </div>
                        </div> -->

            <div class="col-12 md:col-12 xl:col-12  mb-2">
                <div class="card h-full">
                    <ng-container>
                        <div class="flex align-items-center p-3 lg:p-6" style="padding: 0 !important;">
                            <div class="relative flex align-items-left mr-3 font-semibold text-lg">
                                <i class="bi bi-people-fill mr-2"></i>Espectadores total
                            </div>
                            <div class="mr-2">

                            </div>
                            <div class="flex align-items-right ml-auto">
                                <i class="bi bi-info-circle" *ngIf="!isMobileDevice(); else mobileTooltipEspectadores"
                                    pTooltip="Quantidade de espectadores total" tooltipPosition="right"
                                    tooltipEvent="focus" tabindex="0"></i>
                                <ng-template #mobileTooltipEspectadores>
                                    <app-mobile-tooltip text="Quantidade de espectadores total" position="right">
                                        <i class="bi bi-info-circle ml-2"></i>
                                    </app-mobile-tooltip>
                                </ng-template>
                            </div>

                        </div>
                        <div class="flex justify-content-between align-items-start mt-3">
                            <div class="w-12">
                                <span class="text-4xl font-bold text-900" style="margin: 0;">
                                    {{shopping_carts?shopping_carts:0}}</span>
                                <div class="text-green-500">
                                    <!-- <span class="font-medium">
                                                    -13%
                                                </span>
                                                <i class="pi pi-arrow-up text-xs ml-2"></i> -->
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #loadingTemplate>
                        <p-skeleton width="100%" height="1.5rem"></p-skeleton>
                        <p-skeleton width="100%" height="1rem"></p-skeleton>
                        <p-skeleton width="60%" height="1rem"></p-skeleton>
                    </ng-template>
                </div>
            </div>

            <div class="col-12 md:col-12 xl:col-12  mb-2">
                <div class="card h-full">
                    <ng-container>
                        <div class="flex align-items-center p-3 lg:p-6" style="padding: 0 !important;">
                            <div class="relative flex align-items-left mr-3 font-semibold text-lg">
                                <i class="bi bi-easel mr-2"></i> Sessões
                            </div>
                            <div class="mr-2">

                            </div>
                            <div class="flex align-items-right ml-auto">
                                <i class="bi bi-info-circle" *ngIf="!isMobileDevice(); else mobileTooltipEntradas"
                                    pTooltip="Quantidade de vezes que entraram na transmissão" tooltipPosition="right"
                                    tooltipEvent="focus" tabindex="0"></i>
                                <ng-template #mobileTooltipEntradas>
                                    <app-mobile-tooltip text="Quantidade de vezes que entraram na transmissão"
                                        position="right">
                                        <i class="bi bi-info-circle ml-2"></i>
                                    </app-mobile-tooltip>
                                </ng-template>
                            </div>

                        </div>
                        <div class="flex justify-content-between align-items-start mt-3">
                            <div class="w-12">
                                <span class="text-4xl font-bold text-900" style="margin: 0;">
                                    {{sessions}}</span><span
                                    class="ml-4 text-sm text-bluegray-500 ss-l-analytics-txt"></span>
                                <div class="text-green-500">
                                    <!-- <span class="font-medium">
                                                    -13%
                                                </span>
                                                <i class="pi pi-arrow-up text-xs ml-2"></i> -->
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #loadingTemplate>
                        <p-skeleton width="100%" height="1.5rem"></p-skeleton>
                        <p-skeleton width="100%" height="1rem"></p-skeleton>
                        <p-skeleton width="60%" height="1rem"></p-skeleton>
                    </ng-template>
                </div>
            </div>

            <div class="col-12 md:col-12 xl:col-12  mb-2">
                <div class="card h-full">
                    <ng-container>
                        <div class="flex align-items-center p-3 lg:p-6" style="padding: 0 !important;">
                            <div class="relative flex align-items-left mr-3 font-semibold text-lg">
                                <i class="bi bi-clock mr-2"></i> Tempo de permanência
                            </div>
                            <div class="mr-2">

                            </div>
                            <div class="flex align-items-right ml-auto">
                                <i class="bi bi-info-circle" *ngIf="!isMobileDevice(); else mobileTooltipPermanencia"
                                    pTooltip="Tempo médio de permanência na apresentação" tooltipPosition="right"
                                    tooltipEvent="focus" tabindex="0"></i>
                                <ng-template #mobileTooltipPermanencia>
                                    <app-mobile-tooltip text="Tempo médio de permanência na apresentação"
                                        position="right">
                                        <i class="bi bi-info-circle ml-2"></i>
                                    </app-mobile-tooltip>
                                </ng-template>
                            </div>

                        </div>

                        <div class="flex justify-content-between align-items-start mt-3">
                            <div class="w-12">
                                <span class="text-4xl font-bold text-900" style="margin: 0;">
                                    {{ formatTime2(+tmp!) }} ({{timeM}}%)</span>
                                <div class="text-green-500">
                                    <!-- <span class="font-medium">
                                                    -13%
                                                </span>
                                                <i class="pi pi-arrow-up text-xs ml-2"></i> -->
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #loadingTemplate>
                        <p-skeleton width="100%" height="1.5rem"></p-skeleton>
                        <p-skeleton width="100%" height="1rem"></p-skeleton>
                        <p-skeleton width="60%" height="1rem"></p-skeleton>
                    </ng-template>
                </div>
            </div>

            <!-- <div class="col-12 md:col-6 xl:col-12  mb-2">
                            <div class="card h-full">
                                <ng-container>
                                    <span class="font-semibold text-lg"><i class="bi bi-easel-fill mr-2"></i> Tempo
                                        total de live</span>
                                    <div class="flex justify-content-between align-items-start mt-3">
                                        <div class="w-12">
                                            <span class="text-4xl font-bold text-900" style="margin: 0;">
                                                {{ (isNumeric(currentTime) ? formatTime2(+currentTime / 60) :
                                                '00:00:00') }}</span><span
                                                class="ml-4 text-sm text-bluegray-500 ss-l-analytics-txt">Tempo
                                                apresentado</span>
                                            <div class="text-green-500">
                                                <span class="font-medium">
                                                    -13%
                                                </span>
                                                <i class="pi pi-arrow-up text-xs ml-2"></i>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-template #loadingTemplate>
                                    <p-skeleton width="100%" height="1.5rem"></p-skeleton>
                                    <p-skeleton width="100%" height="1rem"></p-skeleton>
                                    <p-skeleton width="60%" height="1rem"></p-skeleton>
                                </ng-template>
                            </div>
                        </div> -->


            <!-- <div class="col-12 md:col-6 xl:col-12  mb-2">
                            <div class="card h-full">
                                <ng-container>
                                    <span class="font-semibold text-lg"><i class="bi bi-cash-coin mr-2"></i> Valor
                                        investido</span>
                                    <div class="flex justify-content-between align-items-start mt-3">
                                        <div class="w-12">
                                            <span class="text-4xl font-bold text-900" style="margin: 0;">
                                                {{ (paid ? paid : 0) | currency:'BRL':'symbol':'1.2-2' }}</span><span
                                                class="ml-4 text-sm text-bluegray-500 ss-l-analytics-txt">Valor
                                                investido na apresentação</span>
                                            <div class="text-green-500">
                                                <span class="font-medium">
                                                    -13%
                                                </span>
                                                <i class="pi pi-arrow-up text-xs ml-2"></i>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-template #loadingTemplate>
                                    <p-skeleton width="100%" height="1.5rem"></p-skeleton>
                                    <p-skeleton width="100%" height="1rem"></p-skeleton>
                                    <p-skeleton width="60%" height="1rem"></p-skeleton>
                                </ng-template>
                            </div>
                        </div> -->

            <div class="col-12 md:col-12 xl:col-12  mb-2">
                <div class="card h-full">
                    <ng-container>
                        <div class="flex align-items-center p-3 lg:p-6" style="padding: 0 !important;">
                            <div class="relative flex align-items-left mr-3 font-semibold text-lg">
                                <i class="bi bi-hand-thumbs-up-fill mr-2"></i>Curtidas
                            </div>
                            <div class="mr-2">

                            </div>
                            <div class="flex align-items-right ml-auto">
                                <i class="bi bi-info-circle" *ngIf="!isMobileDevice(); else mobileTooltipCurtidas"
                                    pTooltip="Quantidade de curtidas" tooltipPosition="right" tooltipEvent="focus"
                                    tabindex="0"></i>
                                <ng-template #mobileTooltipCurtidas>
                                    <app-mobile-tooltip text="Quantidade de curtidas" position="right">
                                        <i class="bi bi-info-circle ml-2"></i>
                                    </app-mobile-tooltip>
                                </ng-template>
                            </div>

                        </div>

                        <div class="flex justify-content-between align-items-start mt-3">
                            <div class="w-12">
                                <span class="text-4xl font-bold text-900" style="margin: 0;">
                                    {{ like_reaction ? like_reaction : 0}}</span>
                                <div class="text-green-500">
                                    <!-- <span class="font-medium">
                                                    -13%
                                                </span>
                                                <i class="pi pi-arrow-up text-xs ml-2"></i> -->
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #loadingTemplate>
                        <p-skeleton width="100%" height="1.5rem"></p-skeleton>
                        <p-skeleton width="100%" height="1rem"></p-skeleton>
                        <p-skeleton width="60%" height="1rem"></p-skeleton>
                    </ng-template>
                </div>
            </div>

        </div>
        <!-- -->


    </div>
    <div class="sidebar-content" *ngIf="mananger == 5">
        <p-message severity="warn" icon="pi pi-info-circle"
            text="Capítulos só estão disponíveis para vídeos com pelo menos 2 minutos e 30 segundos ou mais."
            styleClass="w-full mb-3">
        </p-message>

        <div class="card shadow-none mb-3">
            <div class="flex align-items-center justify-content-between">
                <span class="font-semibold">Habilitar capítulos</span>
                <p-inputSwitch [(ngModel)]="chaptersEnabled" [disabled]="!chaptersAllowed"
                    (ngModelChange)="onChaptersEnabledChange($event)">
                </p-inputSwitch>
            </div>
        </div>

        <div *ngIf="chaptersEnabled">
            <div *ngFor="let chapter of chapters; let i = index" class="card shadow-none mb-2 p-2">
                <div class="flex align-items-center gap-2">
                    <span class="font-semibold text-500 flex-shrink-0 w-1rem text-center">{{ i + 1 }}</span>
                    <div class="flex-shrink-0 w-7rem">
                        <p-inputMask mask="99:99:99" placeholder="00:00:00" [(ngModel)]="chapter.time"
                            (onBlur)="onChapterTimeChange(i)" styleClass="w-full text-center" [disabled]="i === 0">
                        </p-inputMask>
                    </div>
                    <input pInputText class="flex-1 ss-l-chapter-title-input" [(ngModel)]="chapter.title"
                        placeholder="Título do capítulo" (ngModelChange)="onChapterChange()" />
                    <button pButton icon="pi pi-trash" class="p-button-text p-button-danger p-button-sm flex-shrink-0"
                        [ngClass]="{'invisible': i === 0}" [disabled]="i === 0" (click)="removeChapter(i)">
                    </button>
                </div>
            </div>

            <button pButton icon="pi pi-plus" label="Adicionar capítulo" class="w-full p-button-outlined mt-1"
                (click)="addChapter()">
            </button>
        </div>
    </div>

    <div class="sidebar-content" *ngIf="mananger == 6">
        <p>Edite detalhes de seu <b>Slick®</b>.</p>

        <!-- Details -->
        <p-panel header="Details" [toggleable]="true" [collapsed]="true" [toggler]="'header'" styleClass="mb-3 cursor-pointer">
            <div class="flex flex-column mb-2">
                <label class="w-full ss-g-globalClassLabel">Descrição</label>
                <div class="mb-2">
                    <textarea rows="3" cols="30" class="w-full p-inputtextarea p-inputtext p-component p-element"
                        placeholder="ex: Descrição do Slick" (ngModelChange)="handleTruncatedDesc()"
                        [(ngModel)]="slickDesc" pInputTextarea></textarea>
                </div>
            </div>

            <!-- area de upload -->
            <div class="mt-3 mb-2 flex flex-column" *ngIf="!typeLive">
                <app-upload-file *ngIf="isVideo && canEditUpload && !videoPreviewUrl" [accept]="'video'"
                    [fileName]="videoFile?.name || null" [previewUrl]="null" [errorSize]="hasSizeVideoError"
                    [errorType]="hasTypeVideoError" [required]="true" [requiredError]="hasError3"
                    [forceHidePreview]="false" [canEdit]="canEditUpload"
                    (fileSelected)="onFileSelect({ files: [$event] })" (fileInvalid)="handleUploadError($event)"
                    (fileValid)="hasError3 = false" (removeFile)="removeVideo()" [isSlicks]="true"
                    styleClass="border-1 surface-border surface-card border-round">
                </app-upload-file>

                <div *ngIf="videoPreviewUrl"
                    [ngClass]="{'video-upload-container': valSelect1Video.value === 1, 'video-upload-container-landscape': valSelect1Video.value === 2}">
                    <div
                        [ngClass]="{'ss-l-video-container-inner': valSelect1Video.value === 1, 'ss-g-video-container-inner-landscape': valSelect1Video.value === 2}">
                        <video #videoPlayer [src]="videoPreviewUrl" controls [controls]="true" muted [muted]="true"
                            loop [loop]="true"
                            [ngClass]="{'video-preview': valSelect1Video.value === 1, 'video-preview-landscape': valSelect1Video.value === 2}"
                            (ended)="videoPlayer.play()" (canplaythrough)="handleCanPlayThrough()"
                            playsinline></video>
                        <button *ngIf="videoPreviewUrl && canEditUpload" pButton pRipple type="button"
                            icon="pi pi-times"
                            class="p-button-rounded p-button-primary text-sm absolute justify-content-center align-items-center cursor-pointer w-2rem h-2rem"
                            style="top: -10px; right: -10px; cursor: pointer;" (click)="removeVideo()"></button>
                    </div>
                </div>

                <div class="flex align-items-center justify-content-between mt-2" *ngIf="uploadProgressVideo > 0">
                    <p-progressBar [value]="uploadProgressVideo " class="w-full"></p-progressBar>
                </div>
            </div>

            <div class="mt-3 mb-2 flex flex-column" style="padding: 0;">
                <app-upload-file *ngIf="isImage" [accept]="'image'" [fileName]="imageFile?.name || null"
                    [previewUrl]="imagePreviewUrl" [errorSize]="erroTamanhoImagem" [errorType]="erroTipoImagem"
                    [required]="true" [requiredError]="hasError3" [forceHidePreview]="false"
                    [canEdit]="canEditUpload" (fileSelected)="onImageSelect({ files: [$event] })"
                    (fileInvalid)="handleUploadError($event)" (fileValid)="hasError3 = false"
                    (removeFile)="removeImage()" [isSlicks]="true"
                    styleClass="border-1 surface-border surface-card border-round">
                </app-upload-file>

                <div class="flex align-items-center justify-content-between mt-2" *ngIf="uploadProgress > 0">
                    <p-progressBar [value]="uploadProgress" class="w-full"></p-progressBar>
                </div>
            </div>

            <div class="flex align-items-center" *ngIf="typeLive">
                <p-inputSwitch [(ngModel)]="armazenarEvento" class="mr-2" (onChange)="simular()"></p-inputSwitch>
                <label>Armazenar evento e re-play</label>
            </div>
        </p-panel>

        <!-- Tags -->
        <p-panel header="Tags" [toggleable]="true" [collapsed]="true" [toggler]="'header'" styleClass="mb-3 cursor-pointer">
            <div class="flex flex-column w-full gap-2">
                <div class="flex flex-wrap gap-2" *ngIf="productTags.length > 0">
                    <p-tag *ngFor="let tag of productTags" [value]="tag" icon="pi pi-lock" severity="secondary"
                        [pTooltip]="'Removida automaticamente ao desassociar o produto'" tooltipPosition="top">
                    </p-tag>
                </div>
                <p-chips [(ngModel)]="selectedTags" class="w-full" (ngModelChange)="updateTagsString()"
                    separator="," placeholder="Insira uma tag e aperte ',' ou ⏎" styleClass="w-full"></p-chips>
            </div>
        </p-panel>

        <!-- Usage Rights (Instagram only) -->
        <p-panel *ngIf="source_id === 'ig'" header="Solicitar direitos autorais"
            [toggleable]="true" [collapsed]="true" [toggler]="'header'" styleClass="mb-3 cursor-pointer">
            <app-usage-rights *ngIf="currentItem"
                [items]="[currentItem]" mode="panel"
                (saved)="onUsageRightsSaved($event)"
                (commentSent)="onUsageRightsCommentSent($event)">
            </app-usage-rights>
        </p-panel>

        <!-- File info -->
        <p-panel header="File info" [toggleable]="true" [collapsed]="true" [toggler]="'header'" styleClass="mb-3 cursor-pointer">
            <div class="flex flex-column gap-2">
                <div class="flex justify-content-between" *ngIf="handleUser">
                    <span class="text-500">Source</span>
                    <span class="font-medium">{{ handleUser }}</span>
                </div>
                <div class="flex justify-content-between" *ngIf="mediaType">
                    <span class="text-500">Type</span>
                    <span class="font-medium">{{ mediaType === 'shorts' ? 'Video' : 'Image' }}</span>
                </div>
                <div class="flex justify-content-between">
                    <span class="text-500">Format</span>
                    <span class="font-medium text-uppercase">{{ mediaExtension || '—' }}</span>
                </div>
                <div class="flex justify-content-between" *ngIf="mediaAspectRatio">
                    <span class="text-500">Aspect ratio</span>
                    <span class="font-medium">{{ mediaAspectRatio === '1' ? '16:9' : '9:16' }}</span>
                </div>
                <div class="flex justify-content-between" *ngIf="mediaDuration">
                    <span class="text-500">Duration</span>
                    <span class="font-medium">{{ mediaDuration }}s</span>
                </div>
                <div class="flex justify-content-between" *ngIf="source_id">
                    <span class="text-500">Origin</span>
                    <span class="font-medium">
                        <span *ngIf="source_id === 'ig'">Instagram</span>
                        <span *ngIf="source_id === 'tt'">TikTok</span>
                        <span *ngIf="source_id === 'yt'">YouTube</span>
                        <span *ngIf="source_id === 'up'">Upload</span>
                    </span>
                </div>
                <button pButton pRipple label="Baixar" class="p-button-outlined w-full mt-2"
                    [icon]="downloadingMedia ? 'pi pi-spin pi-spinner' : 'pi pi-download'"
                    [disabled]="downloadingMedia" (click)="downloadMedia()"></button>
            </div>
        </p-panel>

        <!-- Thumbnail (apenas vídeo) -->
        <p-panel header="Thumbnail" *ngIf="isVideo" [toggleable]="true" [collapsed]="true" [toggler]="'header'"
            styleClass="mb-3 cursor-pointer">
            <div class="flex flex-column gap-2">
                <label class="w-full ss-g-globalClassLabel">Tipo</label>
                <p-dropdown [options]="thumbnailModeOptions" [(ngModel)]="thumbnailMode" optionLabel="label"
                    optionValue="value" class="w-full" [appendTo]="'body'"
                    (onChange)="onThumbnailModeChange()"></p-dropdown>

                <small class="text-500" *ngIf="thumbnailMode !== 'video' && capturingThumbnail">
                    <i class="pi pi-spin pi-spinner mr-1"></i>
                    {{ thumbnailMode === 'upload' ? 'Enviando imagem...' : 'Capturando primeiro frame do vídeo...' }}
                </small>

                <small class="text-500" *ngIf="thumbnailMode === 'video'">
                    Mova a barra de progresso do vídeo acima até o momento desejado.
                </small>

                <!-- Preview compartilhado pelos 3 modos: mostra a thumbnail atual com
                     botão de remover (X). Remover só limpa a preview — não salva
                     nada sozinho, pra dar espaço do usuário escolher o próximo
                     passo (upload de uma nova, por exemplo). -->
                <app-upload-file [accept]="'image'" [previewUrl]="mediaThumbnail ?? null" [canEdit]="true"
                    [previewVariant]="'logo'"
                    (fileSelected)="onThumbnailFileSelected($event)" (removeFile)="onThumbnailFileRemoved()"
                    styleClass="border-1 surface-border surface-card border-round">
                </app-upload-file>

                <button *ngIf="thumbnailMode === 'video'" pButton label="Salvar imagem deste momento"
                    [icon]="capturingThumbnail ? 'pi pi-spin pi-spinner' : 'pi pi-camera'"
                    [disabled]="capturingThumbnail" class="w-full mt-1"
                    (click)="captureVideoThumbnail()"></button>
            </div>
        </p-panel>

    </div>
    <div class="sidebar-content" *ngIf="mananger == 7">
        <p>Insira seu <b>Short</b> direto em sua loja, landingpage, blog ou aplicação. <a href="#">Saiba
                mais.</a></p>

        <div class="mb-2"> <b>Passo 1 - Selecione o tipo de display</b></div>
        <div class="flex flex-column gap-3 surface-border border-bottom-1 mb-5">
            <div *ngFor="let integration of integrations" class="field-checkbox surface-border border-1 mb-0 card p-0"
                [ngClass]="{'selected-integration': integration === selectedIntegration}">
                <p-radioButton [inputId]="integration.key" class="ml-2" name="integration" [value]="integration"
                    [(ngModel)]="selectedIntegration"></p-radioButton>
                <div class="p-col-fixed col-10 flex ss-l-integration-opc">
                    <i class="pi pi-bolt mr-2 text-4xl"></i>

                    <div>
                        <label [for]="integration.key" class="ml-2">{{ integration.name }}</label>
                        <p *ngIf="integration.key == 'I'">O tamanho e posição de vídeo na página é
                            customizável
                        </p>
                        <p *ngIf="integration.key == 'P'">O vídeo é inserido no canto inferior direito da
                            página
                            e pode ser movido</p>
                    </div>
                </div>

            </div>
            <div class="mb-2"></div>
        </div>
        <div class="mb-2"> <b>Passo 2 - Adicione em sua página</b></div>
        <div class="card bg-blue-200">
            <p class="mb-0"><b>1. Adicione o script da Slicksell ao header de seu site.</b></p>
            <p>Você só precisa adicionar esse script apenas uma vez ao seu site. Se o script já foi
                inserido, pule esta etapa.</p>

            <div class="p-inputgroup ss-g-custom-inputgroup mb-2">
                <input type="text" pInputText [(ngModel)]="script_share" readonly class="custom-input">
                <button pButton pRipple type="button" icon="pi pi-copy" (click)="copiarScript()"
                    class="ss-l-custom-button"></button>
            </div>

            <p class="mt-4 mb-0"><b>2. Adicione seu widget às páginas em que deseja exibir.</b></p>
            <p>Você pode adicionar este script manualmente à sua página ou incluir o endereço usando o
                Slickmap.</p>

            <div class="p-inputgroup ss-g-custom-inputgroup">
                <input type="text" pInputText [(ngModel)]="widget_share" readonly class="custom-input">
                <button pButton pRipple type="button" icon="pi pi-copy" (click)="copiarWidget()"
                    class="ss-l-custom-button"></button>
            </div>

            <p class="mt-4"><b>Slickmap</b></p>

            <div class="p-fluid bg-blue-200 shadow-none border-black-alpha-30">
                <p-chips [(ngModel)]="valuesMaps" separator="," placeholder="Insira uma tag e aperte ',' ou ⏎"
                    (ngModelChange)="showSlickClearFunction()"></p-chips>
                <div class="flex-container" *ngIf="showClearSlickMaps">
                    <a class="ss-g-remove-coupon" (click)="clearSlickMaps()">
                        <i class="pi pi-times"></i> Limpar Slick Maps
                    </a>
                </div>
            </div>

        </div>

    </div>


    <div class="sidebar-content" *ngIf="sidebarGerenciar && mananger == 0">
        <p>Personalize seus vídeos, suas cores e elementos de interação de seus <b>Slicks®</b></p>
        <div class="card">
            <div
                class="grid mx-0 align-center p-justify-between ss-l-custom-slicks-sidebar p-2 surface-border border-bottom-1">

                <div class="col-12 mx-0 p-0 hover:surface-hover transition-colors transition-duration-150 cursor-pointer"
                    style="border-radius: 15px;padding-top: 1.5rem !important;" (click)="openCTA()">
                    <div class="grid mx-0 p-0 mb-3 align-items-center" style="margin: 0;">

                        <div class="col-2 mx-0 p-2">
                            <i class="pi pi-bolt mr-2" style="font-size: 2rem;"></i>
                        </div>

                        <div class="col-8 mx-0 p-0 align-items-center mb-2">
                            <div>
                                <div class="text-xl font-bold mb-1">Elementos Interativos</div>
                                <p>Adicione produtos, botões e mais em seus Slicks</p>
                            </div>
                        </div>

                        <div class="col-2 text-right mx-0 p-2">
                            <i class="bi bi-chevron-right" style="font-size: 1rem; cursor: pointer;"></i>
                        </div>
                    </div>
                </div>

                <!-- Smart Autoplay *ngIf="handleUser" -->

                <div class="col-12 mx-0 p-0 hover:surface-hover transition-colors transition-duration-150 cursor-pointer"
                    style="border-radius: 15px;" (click)="openConfigs()">
                    <div class="grid mx-0 p-0 mb-3 mt-4 align-items-center" style="margin: 0;">

                        <div class="col-2 mx-0 p-2">
                            <i class="bi bi-gear mr-2" style="font-size: 2rem;"></i>
                        </div>

                        <div class="col-8 mx-0 p-0 align-items-center mb-2">
                            <div>
                                <div class="text-xl font-bold mb-1">Configurações e Estilos</div>
                                <p>Customize seu player, thumbnails e muito mais</p>
                            </div>
                        </div>

                        <div class="col-2 text-right mx-0 p-2">
                            <i class="bi bi-chevron-right" style="font-size: 1rem; cursor: pointer;"
                                (click)="openConfigs()"></i>
                        </div>
                    </div>
                </div>

                <!-- Capítulos -->
                <div class="col-12 mx-0 p-0 transition-colors transition-duration-150" style="border-radius: 15px;"
                    [ngClass]="{'hover:surface-hover cursor-pointer': !isImage, 'opacity-40': isImage}"
                    [ngStyle]="{'pointer-events': isImage ? 'none' : 'auto'}" (click)="!isImage && openChapters()">
                    <div class="grid mx-0 p-0 mb-3 mt-4 align-items-center" style="margin: 0;">

                        <div class="col-2 mx-0 p-2">
                            <i class="bi bi-collection-play mr-2" style="font-size: 2rem;"></i>
                        </div>

                        <div class="col-8 mx-0 p-0 align-items-center mb-2">
                            <div>
                                <div class="text-xl font-bold mb-1">Capítulos</div>
                                <p>Divida seu vídeo em segmentos navegáveis</p>
                            </div>
                        </div>

                        <div class="col-2 text-right mx-0 p-2">
                            <i class="bi bi-chevron-right" style="font-size: 1rem;"></i>
                        </div>
                    </div>
                </div>
                <!-- -->

                <!-- <div class="col-12 mx-0 p-0">
                                <div class="grid mx-0 p-0 mb-3 mt-4 align-items-center" style="margin: 0;">

                                    <div class="col-2 mx-0 p-0">
                                        <i class="bi bi-buildings-fill mr-2" style="font-size: 2rem; opacity: 0.5;"></i>
                                    </div>
                                    <div class="col-8 mx-0 p-0 align-items-center mb-2" style="position: relative;">
                                        <div style="opacity: 0.5;">
                                            <div class="text-xl font-bold mb-1">
                                                Teste A/B
                                            </div>
                                            <p>Teste seus vídeos e descubra qual converte mais</p>
                                        </div>
                                        <div class="text-xl font-bold"
                                            style="position: absolute; left: calc(100% - 8em); top: 0;">
                                            <span style="white-space: nowrap;">em breve</span>
                                        </div>
                                    </div>

                                    <div class="col-2 text-right mx-0 p-0">
                                        <i class="bi bi-chevron-right" style="font-size: 2rem; opacity: 0.5;"
                                            (click)="openAB()"></i>
                                    </div>
                                </div>
                            </div> -->

                <!-- -->

                <!-- <div class="col-12 mx-0 p-0 hover:surface-hover transition-colors transition-duration-150 cursor-pointer"
                    style="border-radius: 15px;" (click)="openAnalytics()">
                    <div class="grid mx-0 p-0 mb-3 mt-4 align-items-center" style="margin: 0;">

                        <div class="col-2 mx-0 p-2">
                            <i class="bi bi-graph-up-arrow mr-2" style="font-size: 2rem;"></i>
                        </div>
                        <div class="col-8 mx-0 p-0 align-items-center mb-2">
                            <div>
                                <div class="text-xl font-bold mb-1">Analytics</div>
                                <p>Conheça suas métricas em tempo real</p>
                            </div>
                        </div>

                        <div class="col-2 text-right mx-0 p-2">
                            <i class="bi bi-chevron-right" style="font-size: 1rem; cursor: pointer;"
                                (click)="openAnalytics()"></i>
                        </div>
                    </div>
                </div> -->

                <!-- -->


            </div>

            <!-- -->

            <div class="grid mx-0 align-center p-justify-between ss-l-custom-slicks-sidebar p-2 mt-1">
                <div class="col-12 mx-0 p-0 hover:surface-hover transition-colors transition-duration-150 cursor-pointer"
                    style="border-radius: 15px;" (click)="openDetails()">
                    <div class="grid mx-0 p-0 mb-3 mt-4 align-items-center" style="margin: 0;">

                        <div class="col-2 mx-0 p-2">
                            <i class="bi bi-pencil mr-2" style="font-size: 2rem;"></i>
                        </div>
                        <!-- Conteúdo do centro com título e texto -->
                        <div class="col-8 mx-0 p-0 align-items-center mb-2">
                            <div>
                                <div class="text-xl font-bold mb-1">Detalhes</div>
                                <p>Edite título, descrição e orientações de seu Slick</p>
                            </div>
                        </div>

                        <div class="col-2 text-right mx-0 p-2">
                            <i class="bi bi-chevron-right" style="font-size: 1rem; cursor: pointer;"
                                (click)="openDetails()"></i>
                        </div>
                    </div>
                </div>

                <!-- -->

                <!-- <div class="col-12 mx-0 p-0">
                                <div class="grid mx-0 p-0 mb-3 mt-4 align-items-center" style="margin: 0;">

                                    <div class="col-2 mx-0 p-0">
                                        <i class="pi pi-globe mr-2" style="font-size: 2rem;"></i>
                                    </div>
                                    <div class="col-8 mx-0 p-0 align-items-center mb-2">
                                        <div>
                                            <div class="text-xl font-bold mb-1">Integrações</div>
                                            <p>Integre seu Slick onde quiser -loja e landing pages</p>
                                        </div>
                                    </div>

                                    <div class="col-2 text-right mx-0 p-0">
                                        <i class="bi bi-chevron-right" style="font-size: 2rem; cursor: pointer;"
                                            (click)="openIntegrations()"></i>
                                    </div>
                                </div>
                            </div> -->

            </div>
        </div>
    </div>
    </ng-template>


    <ng-template #managerFooterTpl>
        <div style="text-align: right; overflow-x: auto; overflow-y: hidden; white-space: nowrap;">
            <button pButton pRipple (click)="backStudio()" *ngIf="mananger > 0" label="Voltar"
                [ngClass]="{'p-button-outlined': mananger === 6 || mananger === 7}" class="mr-2"></button>

            <button pButton pRipple (click)="closeSidebarGeral()" *ngIf="mananger !== 7 && mananger !== 6"
                label="Fechar" class="p-button-outlined mr-2"></button>

            <ng-container>
                <ng-container *ngIf="mediaStatus !== undefined && mediaStatus !== null; else publishSkeleton">
                    <button *ngIf="mediaStatus !== 1" pButton pRipple
                        [icon]="loadingBtnNovo ? 'pi pi-spin pi-spinner' : 'pi pi-check'" label="Publicar"
                        (click)="toggleSlickStatus(1)" class="p-button-success" style="width: 143px"></button>
                    <button *ngIf="mediaStatus === 1" pButton pRipple
                        [icon]="loadingBtnNovo ? 'pi pi-spin pi-spinner' : 'pi pi-times'" label="Despublicar"
                        (click)="toggleSlickStatus(0)" class="p-button-outlined p-button-danger"
                        style="width: 143px"></button>
                </ng-container>
                <ng-template #publishSkeleton>
                    <span style="display: inline-block; vertical-align: middle;">
                        <p-skeleton width="143px" height="44px" borderRadius="6px"></p-skeleton>
                    </span>
                </ng-template>
            </ng-container>

            <button pButton pRipple (click)="saveEditSlick()" [loading]="loadingBtn" label="Salvar"
                *ngIf="mananger == 6" class="ml-2"></button>
            <button pButton pRipple (click)="saveSlickMaps()" label="Salvar" [loading]="loadingBtnSlicks"
                *ngIf="mananger == 7" class="ml-2"></button>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <ng-container *ngTemplateOutlet="managerFooterTpl"></ng-container>
    </ng-template>
</p-sidebar>
<p-sidebar [(visible)]="sideBarLinks" position="right" appendTo="body">
    <ng-template pTemplate="header">
        <div style="display: flex; flex-direction: column;">
            <div class="text-xl font-bold mb-1">Editar Links</div>
        </div>
    </ng-template>



    <div class="flex-grow-1 flex flex-column">
        <!-- CARD -->
        <div class="mb-2">
            <span class="mb-2 font-bold text-lg">Card</span>
            <div class="mb-3 mt-2">
                <label class="font-medium">Nome</label>
                <div class="mb-2"></div>
                <input type="text" pInputText [(ngModel)]="LinkSelectedName" placeholder="ex.: Nome"
                    (ngModelChange)="updateLinkName($event)" class="ss-l-half-width-input w-full" />
            </div>
            <div class="mb-3">
                <label class="font-medium">Descrição</label>
                <div class="mb-2"></div>
                <textarea pInputTextarea [(ngModel)]="linkDescription" rows="3"
                    class="w-full text-sm p-inputtextarea p-inputtext" style="resize: vertical;"
                    placeholder="ex.: Varanda gourmet, lazer na cobertura..."
                    (ngModelChange)="updateLinkDescription($event)"></textarea>
            </div>
            <div class="mb-3">
                <label class="font-medium">Icon/Gif</label>
                <div class="mb-2"></div>
                <ng-container *ngIf="!hasIconGif; else iconPreview">
                    <div class="ss-l-upload-dropzone" [class.ss-l-upload-dropzone--active]="iconDragOver"
                        (click)="iconFileInput.click()"
                        (dragover)="$event.preventDefault(); $event.stopPropagation()"
                        (dragenter)="$event.preventDefault(); iconDragOver = true"
                        (dragleave)="iconDragOver = false"
                        (drop)="$event.preventDefault(); iconDragOver = false; onIconDrop($event)">
                        <i class="pi pi-cloud-upload text-3xl text-600"></i>
                        <span class="text-sm text-600 mt-2 text-center">Arraste ou selecione um arquivo aqui</span>
                    </div>
                    <input #iconFileInput type="file" accept="image/png,image/jpeg,image/gif,image/webp,image/svg+xml"
                        (change)="onIconFileSelected($event)" class="hidden" />
                </ng-container>
                <ng-template #iconPreview>
                    <div class="ss-l-upload-dropzone ss-l-upload-dropzone--has-image">
                        <img [src]="iconGifSelected" class="ss-l-upload-preview-img" />
                        <button pButton pRipple type="button" icon="pi pi-times" class="ss-l-upload-close-btn"
                            (click)="removeIconGif()"></button>
                    </div>
                </ng-template>
                <div class="mt-2" *ngIf="uploadIconProgress > 0">
                    <p-progressBar [value]="uploadIconProgress" class="w-full"></p-progressBar>
                </div>
            </div>
            <div class="w-full">
                <div class="w-full mb-2">
                    <label class="font-mediuml">Cor de fundo</label>
                    <div class="mb-2"></div>
                    <p-colorPicker [(ngModel)]="selectedLinkColor" (ngModelChange)="updateLinksColors($event);"
                        format="hex" [ngStyle]="{'width': '30px', 'flex-grow': 0}"></p-colorPicker>
                </div>
                <div class="w-full">
                    <label class="font-medium">Cor do texto</label>
                    <div class="mb-2"></div>
                    <p-colorPicker [(ngModel)]="cardTextColor" (ngModelChange)="updateCardTextColor($event);"
                        format="hex" [ngStyle]="{'width': '30px', 'flex-grow': 0}"></p-colorPicker>
                </div>
            </div>
        </div>
        <hr class="my-2" />
        <!-- BOTÃO -->
        <div class="mb-2">
            <span class="mb-2 font-bold text-lg">Botão</span>
            <div class="mb-2 mt-2">
                <label for="buttonText" class="w-full font-medium">Texto do botão</label>
                <div class="mb-2"></div>
                <input type="text" pInputText [(ngModel)]="buttonText" placeholder="ex.: Aprender já"
                    (ngModelChange)="updateButtonText($event)" class="ss-l-half-width-input w-full" />
            </div>
            <div class="mb-2">
                <label for="pixelId" class="w-full font-medium">URL</label>

                <div class="p-inputgroup mt-2">
                    <span class="p-inputgroup-addon">https://</span>
                    <input type="text" pInputText [(ngModel)]="LinkSelectedURL" placeholder="ex.: www.google.com"
                        (ngModelChange)="updateLinkURL($event)" class="ss-l-half-width-input w-full" />
                </div>
            </div>
            <div class="w-full">
                <div class="w-full mb-2">
                    <label class="font-medium">Cor do botão</label>
                    <div class="mb-2"></div>
                    <p-colorPicker [(ngModel)]="buttonBgColor" (ngModelChange)="updateButtonBgColor($event);"
                        format="hex" appendTo="body" [ngStyle]="{'width': '30px', 'flex-grow': 0}"></p-colorPicker>
                </div>
                <div class="w-full">
                    <label class="font-medium">Cor do texto do botão</label>
                    <div class="mb-2"></div>
                    <p-colorPicker [(ngModel)]="buttonTextColor" (ngModelChange)="updateButtonTextColor($event);"
                        format="hex" appendTo="body" [ngStyle]="{'width': '30px', 'flex-grow': 0}"></p-colorPicker>
                </div>
            </div>
        </div>

        <!-- <div class="mb-4">
            <label for="pixelId" class="w-full ss-g-globalClassLabel">Nome</label>
            <input type="text" pInputText [(ngModel)]="LinkSelectedName" placeholder="ex.: Nome"
                (ngModelChange)="updateLinkName($event)" class="ss-l-half-width-input w-full" />
        </div>

        <div class="mb-4">
            <label class="ss-g-globalClassLabel">Cor de fundo</label>
            <div class="mt-2"></div>
            <div class="flex align-items-center">
                <p-colorPicker [(ngModel)]="selectedLinkColor" (ngModelChange)="updateLinksColors($event);" format="hex"
                    [ngStyle]="{'width': '30px', 'flex-grow': 0}"></p-colorPicker>
            </div>
            <div class="mb-2"></div>
        </div>

        <div class="mb-4">
            <label for="buttonText" class="w-full ss-g-globalClassLabel">Texto do botão</label>
            <input type="text" pInputText [(ngModel)]="buttonText" placeholder="ex.: Aprender já"
                (ngModelChange)="updateButtonText($event)" class="ss-l-half-width-input w-full" />
        </div>

        <div class="mb-4">
            <label for="pixelId" class="w-full ss-g-globalClassLabel">URL</label>
            <div class="p-inputgroup mt-2">
                <span class="p-inputgroup-addon">https://</span>
                <input type="text" pInputText [(ngModel)]="LinkSelectedURL" placeholder="ex.: www.google.com"
                    (ngModelChange)="updateLinkURL($event)" class="ss-l-half-width-input w-full" />
            </div>
        </div>

        <div class="mb-4 w-full">
            <div class="w-full mb-2">
                <label class="ss-g-globalClassLabel">Cor do botão</label>
                <div class="mt-2"></div>
                <div class="flex align-items-center">
                    <p-colorPicker [(ngModel)]="buttonBgColor" (ngModelChange)="updateButtonBgColor($event);" format="hex"
                        appendTo="body" [ngStyle]="{'width': '30px', 'flex-grow': 0}"></p-colorPicker>
                </div>
            </div>
            <div class="w-full">
                <label class="ss-g-globalClassLabel">Cor do texto do botão</label>
                <div class="mt-2"></div>
                <div class="flex align-items-center">
                    <p-colorPicker [(ngModel)]="buttonTextColor" (ngModelChange)="updateButtonTextColor($event);" format="hex"
                        appendTo="body" [ngStyle]="{'width': '30px', 'flex-grow': 0}"></p-colorPicker>
                </div>
            </div>
        </div>


        <div>
            <label for="pixelId" class="w-full ss-g-globalClassLabel">Icon/Gif</label>
            <div class="mt-2"></div>
            <div (click)="displayDialogIconsGifs = true" class="add-icon-container">
                <img [src]="iconGifSelected" style="width: 40px;height: 40px;" *ngIf="hasIconGif">
                <i class="bi bi-plus-circle" *ngIf="!hasIconGif"></i>
                <p *ngIf="!hasIconGif">Click and add your icon, GIF or image</p>
            </div>
        </div> -->

    </div>

    <ng-template pTemplate="footer">
        <div style="text-align: right;">
            <button pButton pRipple (click)="closeSidebarDetailCtasLinks()" label="Fechar"
                class="p-button-outlined"></button>
            <button pButton pRipple label="Salvar" class="ml-2 mr-2"
                [icon]="loadingLinksCtas ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
                [disabled]="loadingLinksCtas" (click)="updateLinks()"></button>
        </div>
    </ng-template>
</p-sidebar>



<p-sidebar [(visible)]="openDialogDrag" position="right" appendTo="body">
    <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2">
            <i class="bi bi-collection-play"></i>
            <span class="font-semibold">Associar Capítulo</span>
        </div>
    </ng-template>

    <div class="flex flex-column gap-3">
        <div class="flex align-items-center gap-2">
            <img [src]="selectedProductForEdit.thumbnail" class="w-3rem h-3rem border-round" style="object-fit: cover;">
            <span class="font-semibold">{{ selectedProductForEdit.name }}</span>
        </div>
        <!-- tet -->
        <div class="surface-border border-top-1 pt-3" (click)="$event.stopPropagation()">
            <label class="block ss-g-globalClassLabel mb-2">Capítulo associado</label>
            <p-dropdown [options]="chapterDropdownOptions" [(ngModel)]="selectedChapterForProduct"
                (ngModelChange)="onChapterProductChange($event)" placeholder="Selecione um capítulo" optionLabel="label"
                optionValue="value" class="w-full">
            </p-dropdown>


            <small class="text-500 mt-2 block">
                Quando esse capítulo iniciar, o produto será destacado automaticamente.
            </small>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <div style="text-align: right;">
            <button pButton pRipple (click)="closeSidebarDetail()" label="Fechar" class="p-button-outlined"></button>
        </div>
    </ng-template>
</p-sidebar>

<p-dialog header="Confirmação" [(visible)]="displayDialog" [modal]="true" [closable]="false" [resizable]="false"
    class="ss-g-dialog-sized">
    <p style="word-wrap: break-word; overflow-wrap: break-word; white-space: normal;">Você será redirecionado para uma
        página externa - {{ tempUrl }}. Deseja continuar?</p>
    <p-footer>
        <button type="button" pButton pRipple label="Sim"
            (click)="confirmRedirect(); $event.stopPropagation()"></button>
        <button type="button" pButton pRipple label="Não" (click)="cancelRedirect(); $event.stopPropagation()"></button>
    </p-footer>
</p-dialog>

<p-dialog header="Confirmação" [(visible)]="displayDialogWhats" [modal]="true" [closable]="false" [resizable]="false"
    class="ss-g-dialog-sized">
    <p style="word-wrap: break-word; overflow-wrap: break-word; white-space: normal;">Você será redirecionado para uma
        página externa - {{ tmpWhasPhone }}. Deseja continuar?</p>
    <p-footer>
        <button type="button" pButton pRipple label="Sim"
            (click)="confirmRedirectWhats(); $event.stopPropagation()"></button>
        <button type="button" pButton pRipple label="Não"
            (click)="cancelRedirectWhats(); $event.stopPropagation()"></button>
    </p-footer>
</p-dialog>
<p-dialog header="Confirmação" [(visible)]="openDialogDuration" [modal]="true" [closable]="false" id="dialogUpload"
    class="ss-g-dialog-sized" [resizable]="false">
    <p>O tempo do vídeo selecionado é menor que o tempo do vídeo removido e pode causar erros nos intervalos já
        definidos dos elementos interativos. Deseja continuar?</p>

    <p-footer>
        <button type="button" pButton pRipple label="Sim"
            (click)="zeraDialogDuration(); $event.stopPropagation()"></button>
        <button type="button" pButton pRipple label="Não"
            (click)="closeDialogDuration(); $event.stopPropagation()"></button>
    </p-footer>
</p-dialog>

<p-dialog header="Simular Preço de live" id="dialogSimulator" class="ss-l-sumulator ss-l-sizeDialogs"
    [(visible)]="simuladorDialog" [modal]="true" [dismissableMask]="true">
    <p>Aprenda a estimar o valor estimado de sua apresentação <b>aqui.</b></p>

    <div class="card shadow-none mb-2" style="z-index: 1102;">
        <div class="mb-2 w-full">
            <label for="tempoDuracao" class="w-full">Tempo de duração <i
                    class="bi bi-info-circle-fill ml-1"></i></label>

            <input id="tempoDuracao" class="grid m-0 w-full ss-l-timeDurationSimulator" inputmode="numeric" mask="00:00"
                [(ngModel)]="liveTime" (ngModelChange)="correctMinutes($event)" placeholder="ex: 00:15" type="text"
                pInputText [ngClass]="{'ng-invalid': hasErrorTime, 'ng-dirty': hasErrorTime}" />

        </div>
        <div class="flex align-items-center justify-content-between">
            <!-- Mensagem de Erro à esquerda -->
            <small *ngIf="hasErrorTime" class="p-error">
                Obrigatório
            </small>
        </div>
        <div class="mb-2">
            <label for="autocomplete-cliente" class="w-full">Espectadores <i
                    class="bi bi-info-circle-fill ml-1"></i></label>
            <input type="text" pInputText class="w-full" [(ngModel)]="viewers" inputmode="numeric"
                (input)="onlyNumber($event)" placeholder="ex: 20"
                [ngClass]="{'ng-invalid': hasErrorViewers, 'ng-dirty': hasErrorViewers}">
        </div>
        <div class="flex align-items-center justify-content-between">
            <!-- Mensagem de Erro à esquerda -->
            <small *ngIf="hasErrorViewers" class="p-error">
                Obrigatório
            </small>
        </div>
        <div class="mb-2">
            <label for="autocomplete-cliente" class="w-full">Tempo médio de permanência <i
                    class="bi bi-info-circle-fill ml-1"></i>

                <p-dropdown [options]="targetTime" id="dropdown-time" placeholder="Selecione o tempo"
                    (click)="forceFocus($event)"
                    [ngClass]="{'ng-invalid': hasErrorSelectedTime, 'ng-dirty': hasErrorSelectedTime}"
                    class="w-full ss-g-sidebarVendas" [(ngModel)]="selectedTime" optionLabel="label">
                </p-dropdown>
            </label>
        </div>
        <div class="flex align-items-center justify-content-between">
            <!-- Mensagem de Erro à esquerda -->
            <small *ngIf="hasErrorSelectedTime" class="p-error">
                Obrigatório
            </small>
        </div>
        <button pButton pRipple label="Simular" class="w-full mt-2" (click)="simular()"
            [loading]="loadingSimulate"></button>
        <div class="flex flex-column align-items-start mt-2 mb-2 ">
            <div class="text-xs font-light mb-2">
                <div>
                    <i class="bi bi-question-circle-fill mr-1"></i> <b>Investimento</b>
                </div>
                <p>O custo estimado é <b>R$ {{ resultSimulatePrice }}</b></p>
            </div>
            <p>O custo final de sua transmissão pode variar conforme seu evento como <b>tempo de duração,
                    espectadores</b> e <b>tempo de permanência.</b>
                Conheça nossas taxas <a href="#">aqui.</a></p>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <div style="text-align: right;">
            <button pButton pRipple (click)="closeLive()" label="Fechar" class="p-button-outlined"></button>
        </div>
    </ng-template>
</p-dialog>

<p-dialog header="RTMP infos" [(visible)]="displayRTMPInofos" [modal]="true" style="z-index: 1102;"
    [dismissableMask]="true" class="ss-g-dialog-sized">
    Conteúdo
</p-dialog>

<p-dialog header="Erro durante a conexão" [(visible)]="dialogVisible" [modal]="true" [closable]="true"
    [showHeader]="true" class="ss-g-dialog-sized">
    <p>{{ errorMessage }}</p>
    <p-footer>
        <button type="button" pButton label="Fechar" pButton pRipple class="p-button-outlined"
            (click)="closeDialog()"></button>
    </p-footer>
</p-dialog>
<p-dialog header="Erro durante a conexão" [(visible)]="dialogVisibleError" [modal]="true" [closable]="true"
    [showHeader]="true" class="ss-g-dialog-sized">
    <p>{{ errorMessage }}</p>
    <p-footer>
        <button type="button" pButton label="Fechar" pButton pRipple class="p-button-outlined"
            (click)="closeDialogError()"></button>
        <button type="button" label="Desconectar" pButton pRipple (click)="disconectSocket()"></button>
    </p-footer>
</p-dialog>

<p-dialog header="Confirmação" [(visible)]="showConfirmDialog" [modal]="true" [closable]="false" [showHeader]="true"
    class="ss-g-dialog-sized">
    <p>Tem certeza de que deseja interromper a transmissão?</p>
    <p-footer>
        <button pButton pRipple label="Sim" (click)="stopMediaTracks(stream); showConfirmDialog = false;"></button>
        <button pButton pRipple label="Não" (click)="closeDialogConfirmation()"></button>
    </p-footer>
</p-dialog>

<p-dialog [baseZIndex]="100" class="ss-l-sizeDialogs" header="Selecione um ícone, gif ou adicione"
    [(visible)]="displayDialogIconsGifs" id="iconsGifs" [modal]="true" [dismissableMask]="true">

    <p-tabMenu [model]="linksOptions" [ngStyle]="{'max-width': '90vw !important'}" [(activeItem)]="activeLinkOption"
        (change)="changeCtaLink()" [scrollable]="false">
    </p-tabMenu>

    <div *ngIf="activeLinkOption?.label === 'Ícones'" style="max-width: 90vw !important;">
        <div class="mt-2 mb-2 search-container">
            <span class="p-float-label p-input-icon-right w-full mb-2">
                <input type="text" class="w-full" pInputText [(ngModel)]="nameIconSearch" (input)="searchIcons()"
                    placeholder="Buscar ícones...">
                <i *ngIf="!loadingLinks; else loading" class="pi pi-search" style="top: 28px !important;"></i>
                <ng-template #loading>
                    <i class="pi pi-spin pi-spinner"></i>
                </ng-template>
            </span>
            <a *ngIf="totalRecordsIcons > 0" class="ss-g-remove-coupon mt-2" style="cursor: pointer;"
                (click)="clearSearchIcons()">
                <i class="pi pi-times"></i> Limpar Busca
            </a>
        </div>

        <div class="mb-2">
            <label class="ss-g-globalClassLabel">Cor</label>
            <div class="button-row">
                <div class="button-row2">
                    <p-selectButton [options]="linkOptions" [(ngModel)]="valSelect1" optionLabel="label"
                        (ngModelChange)="setIconGifColor($event)">
                    </p-selectButton>
                </div>
            </div>
        </div>
        <div>
            <label class="ss-g-globalClassLabel">Shapes</label>
            <div class="button-row">
                <p-selectButton [options]="linkOptionsGif" [(ngModel)]="valSelect2" optionLabel="label"
                    (ngModelChange)="setIconGifShape($event)">
                </p-selectButton>
            </div>
        </div>
        <div class="dataView-container">
            <p-dataView [value]="icons" [lazy]="true" layout="grid" [paginator]="true" [rows]="96"
                [totalRecords]="totalRecordsIcons" (onLazyLoad)="loadData($event)">
                <ng-template pTemplate="gridItem" let-icon>
                    <div class="p-col-12 p-md-6 p-lg-2_4 icon-container1 card p-4" style="max-height: 60px;"
                        (click)="getIcon(icon.thumbnails[0]?.url)">
                        <img [src]="icon.thumbnails[0]?.url" [alt]="icon.name" style="width: 40px;height: 40px;"
                            *ngIf="icon.thumbnails.length > 0" loading="lazy">
                    </div>
                </ng-template>
                <ng-template pTemplate="loadingItem">
                    <div class="p-col-12 p-md-6 p-lg-2_4 icon-container1">
                        <div class="skeleton-image"></div>
                        <div class="skeleton-text"></div>
                        <div class="skeleton-text"></div>
                        <div class="skeleton-text"></div>
                        <div class="skeleton-text"></div>
                    </div>
                </ng-template>
            </p-dataView>
        </div>
    </div>
    <div *ngIf="activeLinkOption?.label === 'Custom'">
        <!-- Conteúdo para Custom -->

        <div class="mt-4 mb-4">Colar url do icon ou gif desejado (Formato PNG/GiF)</div>
        <div class="w-full text-center mb-4">
            <input type="text" pInputText [(ngModel)]="tempIconGifUrl" (input)="onInputChange2()" class="w-full">
            <div class="flex align-items-center justify-content-between">
                <small *ngIf="errorGif" class="p-error">
                    Verificar formato de imagem
                </small>

            </div>
        </div>
        <div class="w-full text-right">
            <button pButton pRipple (click)="selectIconGif(tempIconGifUrl)" label="OK"></button>
        </div>

    </div>
    <div *ngIf="activeLinkOption?.label === 'GIFS'">
        <!-- Conteúdo para GIFS -->
        <div class="mt-2 mb-2 search-container">
            <span class="p-float-label p-input-icon-right w-full mb-2">
                <input type="text" class="w-full" pInputText [(ngModel)]="nameGifSearch" (input)="searchGifs()"
                    placeholder="Buscar gifs...">
                <!-- <label for="righticon">Buscar Ícones</label> -->
                <i *ngIf="!loadingLinks; else loading" class="pi pi-search" style="top: 28px !important;"></i>
                <ng-template #loading>
                    <i class="pi pi-spin pi-spinner"></i>
                </ng-template>
            </span>
            <a *ngIf="totalRecordsGifs > 0" class="ss-g-remove-coupon mt-2" style="cursor: pointer;"
                (click)="clearSearchGifs()">
                <i class="pi pi-times"></i> Limpar Busca
            </a>
        </div>
        <div class="dataView-container">
            <p-dataView [value]="gifs" layout="grid" [lazy]="true" (onLazyLoad)="loadDataGifs($event)"
                [totalRecords]="totalRecordsGifs" [paginator]="true" [rows]="25">
                <ng-template pTemplate="gridItem" let-gif>
                    <!-- Certifique-se de que a variável 'gif' é usada dentro de ng-template dataView-container-->
                    <div class="p-col-12 p-md-6 p-lg-2_4 icon-container card p-4 gap-5 not-last"
                        (click)="getIcon(gif.images.downsized.url)">
                        <img [src]="gif.images.downsized.url" [alt]="gif.title" style="width: 40px;height: 40px;"
                            loading="lazy">
                    </div>
                </ng-template>
                <ng-template pTemplate="loadingItem">
                    <div class="p-col-12 p-md-6 p-lg-2_4 icon-container">
                        <div class="skeleton-image"></div>
                        <div class="skeleton-text"></div>
                        <div class="skeleton-text"></div>
                        <div class="skeleton-text"></div>
                        <div class="skeleton-text"></div>
                    </div>
                </ng-template>
            </p-dataView>
        </div>

    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple (click)="closeIconsModal()" label="Fechar" class="p-button-outlined"></button>
    </ng-template>
</p-dialog>



<p-dialog header="Conexão Perdida" [(visible)]="displayReconnectDialog"
    class="ss-l-sizeDialogs dialogReconnect ss-g-dialog-sized" [modal]="true" [closable]="false">

    <div class="p-d-flex p-ai-center p-jc-center p-flex-column">
        <p-progressSpinner></p-progressSpinner>
        <p>{{ reconnectMessage }}</p>
        <p>Um erro ocorreu. Verifique sua conexão, saldo e plano contratdo ou entre em contato com o
            suporte.</p>
    </div>
    <p-footer>
        <button type="button" pButton label="Desconectar" icon="pi pi-times" (click)="onDisconnectClick()"></button>
    </p-footer>
</p-dialog>

<p-dialog header="Trocando a câmera" id="switchCam" [(visible)]="displayChangeCameraDialog" [modal]="true"
    class="dialogReconnect ss-l-sizeDialogs" [closable]="false">
    <div class="p-d-flex p-ai-center p-jc-center p-flex-column">
        <p-progressSpinner></p-progressSpinner>
        <p>{{ changeCameraMessage }}</p>
    </div>
</p-dialog>

<app-upgrade-dialog [(visible)]="showUpgradeDialog" [title]="upgradeDialogTitle" [message]="upgradeDialogMessage"
    (close)="showUpgradeDialog = false" (upgrade)="irParaAssinatura()">
</app-upgrade-dialog>

<!-- <p-toast [baseZIndex]="1200"></p-toast> -->